import { z } from "zod";
// \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
// src/generated/common.ts
var common_exports = /* @__PURE__ */ __exportAll({
	AppLink: () => AppLink,
	Binary: () => Binary,
	ContactDetails: () => ContactDetails,
	ContactMessage: () => ContactMessage,
	Email: () => Email,
	Empty: () => Empty,
	ErrorBody: () => ErrorBody,
	Ok: () => Ok,
	Query: () => Query,
	ReasonedRevision: () => ReasonedRevision,
	Revision: () => Revision,
	Token: () => Token
});
const Empty = z.strictObject({});
const Ok = z.strictObject({ ok: z.literal(true) });
const Revision = z.strictObject({ expectedRevision: z.number().int().min(1) });
const ReasonedRevision = z.strictObject({
	expectedRevision: z.number().int().min(1),
	reason: z.string().min(10).max(2e3)
});
const Query = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.string().min(1).max(40).optional(),
	areaId: z.uuid().optional(),
	templateId: z.uuid().optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional(),
	ownerId: z.uuid().optional(),
	sort: z.enum([
		"createdAt",
		"effectiveAt",
		"state",
		"name"
	]).optional(),
	minScore: z.number().min(0).max(100).optional(),
	maxScore: z.number().min(0).max(100).optional()
});
const ErrorBody = z.strictObject({ error: z.strictObject({
	code: z.string().min(1).max(80),
	message: z.string().min(1).max(500),
	requestId: z.uuid(),
	retryable: z.boolean(),
	fieldErrors: z.array(z.strictObject({
		path: z.string().min(1).max(200),
		message: z.string().min(1).max(500)
	})).max(200).optional()
}) });
const Email = z.strictObject({ email: z.email() });
const Token = z.strictObject({ token: z.string().min(16).max(512) });
const ContactDetails = z.strictObject({ area: z.enum([
	"5s",
	"account",
	"other"
]).nullable() });
const ContactMessage = z.strictObject({
	topic: z.enum([
		"evaluation",
		"support",
		"security",
		"other"
	]),
	name: z.string().min(1).max(120),
	email: z.email(),
	organization: z.string().min(1).max(160).nullable(),
	message: z.string().min(20).max(4e3),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	details: ContactDetails,
	turnstileToken: z.string().min(1).max(2048)
});
const AppLink = z.strictObject({
	app: z.enum(["platform", "fiveS"]),
	path: z.string().min(1).max(1e3)
});
const Binary = z.string();
// src/generated/account.ts
var account_exports = /* @__PURE__ */ __exportAll({
	AcceptInvitation: () => AcceptInvitation,
	Avatar: () => Avatar,
	AvatarProvider: () => AvatarProvider,
	LinkedAccount: () => LinkedAccount,
	LinkedAccountList: () => LinkedAccountList,
	ListMyOrganizationsQuery: () => ListMyOrganizationsQuery,
	ListNotificationsQuery: () => ListNotificationsQuery,
	ListScopesQuery: () => ListScopesQuery,
	ListSessionsQuery: () => ListSessionsQuery,
	MfaAcknowledge: () => MfaAcknowledge,
	MfaChallenge: () => MfaChallenge,
	MfaRecoveryCodes: () => MfaRecoveryCodes,
	MfaSetup: () => MfaSetup,
	Notification: () => Notification,
	NotificationList: () => NotificationList,
	OrganizationChoice: () => OrganizationChoice,
	OrganizationChoiceList: () => OrganizationChoiceList,
	Passkey: () => Passkey,
	PasskeyList: () => PasskeyList,
	PasskeyRegistration: () => PasskeyRegistration,
	PasskeySignIn: () => PasskeySignIn,
	PasswordChange: () => PasswordChange,
	Profile: () => Profile,
	ProviderRedirect: () => ProviderRedirect,
	Reauthenticate: () => Reauthenticate,
	ResetPassword: () => ResetPassword,
	Scope: () => Scope,
	ScopeList: () => ScopeList,
	Session: () => Session,
	SignIn: () => SignIn,
	SignInOptions: () => SignInOptions,
	SocialProvider: () => SocialProvider,
	SocialSignIn: () => SocialSignIn,
	UserSession: () => UserSession,
	UserSessionList: () => UserSessionList,
	WebAuthnOptions: () => WebAuthnOptions
});
const SignIn = z.strictObject({
	email: z.email(),
	password: z.string().min(1).max(128)
});
const Session = z.strictObject({
	userId: z.uuid(),
	name: z.string().min(1).max(200),
	avatarUrl: z.string().min(1).max(1e3).nullable(),
	email: z.email(),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	expiresAt: z.iso.datetime({ offset: true }),
	mfaRequired: z.boolean(),
	mfaEnrollmentRequired: z.boolean(),
	challengeId: z.string().min(1).max(200).nullable(),
	mfaEnrolled: z.boolean(),
	isOperator: z.boolean(),
	impersonation: z.strictObject({
		id: z.uuid(),
		operatorName: z.string().min(1).max(200),
		organizationId: z.uuid(),
		organizationName: z.string().min(1).max(200),
		access: z.enum(["read", "write"]),
		expiresAt: z.iso.datetime({ offset: true })
	}).nullable()
});
const SignInOptions = z.strictObject({
	providers: z.array(z.enum(["microsoft", "google"])).max(2),
	passkeys: z.boolean()
});
const SocialSignIn = z.strictObject({
	provider: z.enum(["microsoft", "google"]),
	next: z.string().min(1).max(2e3).nullable()
});
const ProviderRedirect = z.strictObject({ url: z.string().min(1).max(4e3) });
const SocialProvider = z.strictObject({ provider: z.enum(["microsoft", "google"]) });
const LinkedAccount = z.strictObject({
	provider: z.enum(["microsoft", "google"]),
	linked: z.boolean(),
	linkedAt: z.iso.datetime({ offset: true }).nullable()
});
const WebAuthnOptions = z.strictObject({ options: z.record(z.string(), z.unknown()).refine((v) => Object.keys(v).length <= 30, "Too many entries") });
const PasskeyRegistration = z.strictObject({
	name: z.string().min(1).max(80),
	response: z.record(z.string(), z.unknown()).refine((v) => Object.keys(v).length <= 30, "Too many entries")
});
const PasskeySignIn = z.strictObject({ response: z.record(z.string(), z.unknown()).refine((v) => Object.keys(v).length <= 30, "Too many entries") });
const Passkey = z.strictObject({
	id: z.uuid(),
	name: z.string().min(1).max(80).nullable(),
	createdAt: z.iso.datetime({ offset: true }),
	backedUp: z.boolean()
});
const ResetPassword = z.strictObject({
	token: z.string().min(16).max(512),
	password: z.string().min(12).max(128)
});
const AcceptInvitation = z.strictObject({
	token: z.string().min(16).max(512),
	name: z.string().min(1).max(200).optional(),
	password: z.string().min(12).max(128).optional()
});
const MfaChallenge = z.strictObject({
	challengeId: z.string().min(1).max(200),
	code: z.string().min(6).max(128)
});
const MfaSetup = z.strictObject({
	challengeId: z.string().min(1).max(200),
	secretUri: z.string().min(1).max(1e3)
});
const Avatar = z.strictObject({
	url: z.string().min(1).max(1e3).nullable(),
	source: z.enum([
		"upload",
		"microsoft",
		"google"
	]).nullable(),
	providers: z.array(z.enum(["microsoft", "google"])).max(2)
});
const AvatarProvider = z.strictObject({ provider: z.enum(["microsoft", "google"]) });
const MfaRecoveryCodes = z.strictObject({ recoveryCodes: z.array(z.string().min(1).max(100)).max(20) });
const MfaAcknowledge = z.strictObject({
	challengeId: z.string().min(1).max(200),
	backupCode: z.string().min(12).max(20)
});
const PasswordChange = z.strictObject({
	currentPassword: z.string().min(1).max(128),
	newPassword: z.string().min(12).max(128)
});
const Profile = z.strictObject({
	name: z.string().min(1).max(200),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	theme: z.enum([
		"system",
		"light",
		"dark"
	]),
	emailNotifications: z.boolean()
});
const Reauthenticate = z.strictObject({
	password: z.string().min(1).max(128),
	secondFactor: z.string().min(6).max(128).optional()
});
const UserSession = z.strictObject({
	id: z.uuid(),
	createdAt: z.iso.datetime({ offset: true }),
	lastSeenAt: z.iso.datetime({ offset: true }),
	deviceLabel: z.string().min(1).max(200),
	current: z.boolean()
});
const Scope = z.strictObject({
	organizationId: z.uuid(),
	organizationName: z.string().min(1).max(200),
	workspaceId: z.uuid(),
	workspaceName: z.string().min(1).max(200),
	role: z.enum([
		"administrator",
		"consultant",
		"viewer"
	]),
	retired: z.boolean(),
	workspacePublicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const Notification = z.strictObject({
	id: z.uuid(),
	kind: z.enum([
		"finding",
		"share",
		"export",
		"templateUpdate",
		"allowance",
		"invitation",
		"service"
	]),
	title: z.string().min(1).max(300),
	target: AppLink,
	read: z.boolean(),
	createdAt: z.iso.datetime({ offset: true })
});
const OrganizationChoice = z.strictObject({
	id: z.uuid(),
	name: z.string().min(1).max(200),
	role: z.enum(["administrator", "member"]),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const UserSessionList = z.strictObject({
	items: z.array(UserSession).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const LinkedAccountList = z.strictObject({
	items: z.array(LinkedAccount).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const PasskeyList = z.strictObject({
	items: z.array(Passkey).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ScopeList = z.strictObject({
	items: z.array(Scope).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const OrganizationChoiceList = z.strictObject({
	items: z.array(OrganizationChoice).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const NotificationList = z.strictObject({
	items: z.array(Notification).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListSessionsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListScopesQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum(["active", "all"]).optional()
});
const ListMyOrganizationsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListNotificationsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	status: z.enum(["read", "unread"]).optional()
});
// src/generated/areas.ts
var areas_exports = /* @__PURE__ */ __exportAll({
	Area: () => Area,
	AreaCreate: () => AreaCreate,
	AreaList: () => AreaList,
	AreaUpdate: () => AreaUpdate,
	ListAreasQuery: () => ListAreasQuery
});
const Area = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	order: z.number().int().min(0),
	retired: z.boolean(),
	templateId: z.uuid().nullable(),
	facts: z.array(z.enum([
		"hazardousSubstances",
		"ppeRequired",
		"deskWork"
	])).max(3),
	nameLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable()
});
const AreaCreate = z.strictObject({
	name: z.string().min(1).max(200),
	templateId: z.uuid(),
	facts: z.array(z.enum([
		"hazardousSubstances",
		"ppeRequired",
		"deskWork"
	])).max(3).optional()
});
const AreaUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	facts: z.array(z.enum([
		"hazardousSubstances",
		"ppeRequired",
		"deskWork"
	])).max(3).optional()
});
const AreaList = z.strictObject({
	items: z.array(Area).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListAreasQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum(["active", "retired"]).optional(),
	sort: z.enum(["name", "createdAt"]).optional()
});
// src/generated/templates.ts
var templates_exports = /* @__PURE__ */ __exportAll({
	Band: () => Band,
	Category: () => Category,
	ChoiceOption: () => ChoiceOption,
	DraftCategory: () => DraftCategory,
	DraftQuestion: () => DraftQuestion,
	DraftTemplateDefinition: () => DraftTemplateDefinition,
	ImportCsv: () => ImportCsv,
	ImportPreview: () => ImportPreview,
	ListTemplateVersionsQuery: () => ListTemplateVersionsQuery,
	ListTemplatesQuery: () => ListTemplatesQuery,
	ListWorkspaceTemplateVersionsQuery: () => ListWorkspaceTemplateVersionsQuery,
	Question: () => Question,
	Scoring: () => Scoring,
	Template: () => Template,
	TemplateAreas: () => TemplateAreas,
	TemplateAreasUpdate: () => TemplateAreasUpdate,
	TemplateCreate: () => TemplateCreate,
	TemplateDefinition: () => TemplateDefinition,
	TemplateFlags: () => TemplateFlags,
	TemplateList: () => TemplateList,
	TemplateMergeConflict: () => TemplateMergeConflict,
	TemplateUpdate: () => TemplateUpdate,
	TemplateVersion: () => TemplateVersion,
	TemplateVersionList: () => TemplateVersionList
});
const ChoiceOption = z.strictObject({
	key: z.string().min(1).max(80),
	label: z.string().min(1).max(300),
	value: z.number(),
	quality: z.number().min(0).max(100),
	critical: z.boolean()
});
const Band = z.strictObject({
	lower: z.number(),
	upper: z.number(),
	includeUpper: z.boolean(),
	quality: z.number().min(0).max(100),
	critical: z.boolean(),
	label: z.string().min(1).max(300)
});
const Scoring = z.discriminatedUnion("kind", [z.strictObject({
	kind: z.literal("choice"),
	options: z.array(ChoiceOption).min(2).max(10)
}), z.strictObject({
	kind: z.literal("numericBands"),
	minimum: z.number(),
	maximum: z.number(),
	step: z.number().gt(0),
	unit: z.string().min(1).max(80),
	bands: z.array(Band).min(1).max(20)
})]);
const Question = z.strictObject({
	key: z.string().min(1).max(80),
	title: z.string().min(1).max(300),
	description: z.string().max(2e3),
	required: z.boolean(),
	allowNotApplicable: z.boolean(),
	weight: z.number().min(.01).max(100),
	scoring: Scoring,
	showWhen: z.array(z.enum([
		"hazardousSubstances",
		"ppeRequired",
		"deskWork"
	])).max(3).optional(),
	prefill: z.enum(["previousOpenActions"]).optional()
});
const Category = z.strictObject({
	key: z.string().min(1).max(80),
	title: z.string().min(1).max(300),
	weight: z.number().min(.01).max(100),
	questions: z.array(Question).min(1).max(200),
	description: z.string().max(2e3).optional(),
	kind: z.enum(["scored", "safety"]).optional()
});
const TemplateDefinition = z.strictObject({
	title: z.string().min(1).max(200),
	description: z.string().max(2e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	aggregation: z.literal("weightedCategoryMean"),
	displayMaximum: z.union([z.literal(10), z.literal(100)]),
	categories: z.array(Category).min(1).max(20),
	fieldLocales: z.record(z.string(), z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	])).refine((v) => Object.keys(v).length <= 2e3, "Too many entries").optional()
});
const DraftQuestion = z.strictObject({
	key: z.string().min(1).max(80),
	title: z.string().max(300),
	description: z.string().max(2e3),
	required: z.boolean(),
	allowNotApplicable: z.boolean(),
	weight: z.number().min(.01).max(100),
	scoring: Scoring.nullable(),
	showWhen: z.array(z.enum([
		"hazardousSubstances",
		"ppeRequired",
		"deskWork"
	])).max(3).optional(),
	prefill: z.enum(["previousOpenActions"]).optional()
});
const DraftCategory = z.strictObject({
	key: z.string().min(1).max(80),
	title: z.string().max(300),
	weight: z.number().min(.01).max(100),
	questions: z.array(DraftQuestion).max(200),
	description: z.string().max(2e3).optional(),
	kind: z.enum(["scored", "safety"]).optional()
});
const DraftTemplateDefinition = z.strictObject({
	title: z.string().max(200),
	description: z.string().max(2e3),
	aggregation: z.literal("weightedCategoryMean"),
	displayMaximum: z.union([z.literal(10), z.literal(100)]),
	categories: z.array(DraftCategory).max(20)
});
const TemplateMergeConflict = z.strictObject({
	path: z.string().min(1).max(500),
	current: z.string().max(8e3),
	incoming: z.string().max(8e3)
});
const Template = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	title: z.string().min(1).max(200),
	activeVersionId: z.uuid().nullable(),
	isDefault: z.boolean(),
	retired: z.boolean(),
	draft: DraftTemplateDefinition.nullable(),
	starterKey: z.string().min(1).max(80).nullable(),
	mergeConflicts: z.array(TemplateMergeConflict).max(500),
	contentLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	titleLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const TemplateCreate = z.strictObject({
	definition: DraftTemplateDefinition,
	editLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional()
});
const TemplateUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	definition: DraftTemplateDefinition,
	resolvedConflictPaths: z.array(z.string().min(1).max(500)).max(500).optional(),
	editLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional()
});
const TemplateVersion = z.strictObject({
	id: z.uuid(),
	templateId: z.uuid(),
	number: z.number().int().min(1),
	definition: TemplateDefinition,
	scoringSignature: z.string().min(64).max(64),
	publishedAt: z.iso.datetime({ offset: true }),
	privacyRevision: z.number().int().min(0)
});
const ImportCsv = z.strictObject({
	csv: z.string().min(1).max(1048576),
	delimiter: z.enum([",", ";"]),
	title: z.string().min(1).max(200),
	description: z.string().max(2e3),
	displayMaximum: z.union([z.literal(10), z.literal(100)])
});
const ImportPreview = z.strictObject({
	definition: DraftTemplateDefinition.nullable(),
	errors: z.array(z.strictObject({
		row: z.number().int().min(0),
		column: z.string().min(1).max(80),
		message: z.string().min(1).max(500)
	})).max(500)
});
const TemplateFlags = z.strictObject({
	expectedRevision: z.number().int().min(1),
	isDefault: z.boolean(),
	retired: z.boolean()
});
const TemplateAreas = z.strictObject({
	templateId: z.uuid(),
	revision: z.number().int().min(1),
	areas: z.array(Area).max(200)
});
const TemplateAreasUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	areaIds: z.array(z.uuid()).max(200)
});
const TemplateList = z.strictObject({
	items: z.array(Template).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const TemplateVersionList = z.strictObject({
	items: z.array(TemplateVersion).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListTemplatesQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"published",
		"draft",
		"retired"
	]).optional(),
	sort: z.enum(["name", "createdAt"]).optional()
});
const ListTemplateVersionsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListWorkspaceTemplateVersionsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
// src/generated/audits.ts
var audits_exports = /* @__PURE__ */ __exportAll({
	Answer: () => Answer,
	AnswerList: () => AnswerList,
	AnswerUpdate: () => AnswerUpdate,
	AnswerValue: () => AnswerValue,
	Audit: () => Audit,
	AuditAccess: () => AuditAccess,
	AuditAccessUpdate: () => AuditAccessUpdate,
	AuditContext: () => AuditContext,
	AuditCreate: () => AuditCreate,
	AuditList: () => AuditList,
	AuditMetadata: () => AuditMetadata,
	AuditRevision: () => AuditRevision,
	AuditSummary: () => AuditSummary,
	AuditSummaryList: () => AuditSummaryList,
	CategoryScore: () => CategoryScore,
	ListAnswersQuery: () => ListAnswersQuery,
	ListAuditsQuery: () => ListAuditsQuery,
	ListRemarksQuery: () => ListRemarksQuery,
	ListRevisionRemarksQuery: () => ListRevisionRemarksQuery,
	PreviousAuditQuery: () => PreviousAuditQuery,
	PreviousComparableAudit: () => PreviousComparableAudit,
	Remark: () => Remark,
	RemarkCreate: () => RemarkCreate,
	RemarkList: () => RemarkList,
	RemarkUpdate: () => RemarkUpdate,
	Score: () => Score,
	Submit: () => Submit
});
const CategoryScore = z.strictObject({
	key: z.string().min(1).max(80),
	value: z.number().min(0).max(100).nullable(),
	categoryWeight: z.number().min(.01).max(100),
	answeredWeight: z.number().min(0),
	totalQuestionWeight: z.number().gt(0),
	requiredAnswered: z.number().int().min(0),
	requiredTotal: z.number().int().min(0)
});
const Score = z.strictObject({
	value: z.number().min(0).max(100).nullable(),
	provisional: z.boolean(),
	requiredAnswered: z.number().int().min(0),
	requiredTotal: z.number().int().min(0),
	applicableWeight: z.number().min(0),
	totalWeight: z.number().min(0),
	critical: z.boolean(),
	categories: z.array(CategoryScore).max(20),
	criticalCount: z.number().int().min(0)
});
const AuditContext = z.strictObject({
	department: z.string().min(1).max(200).nullable(),
	additionalAuditors: z.string().min(1).max(1e3).nullable(),
	highlight: z.string().max(4e3).nullable(),
	mainConcern: z.string().max(4e3).nullable()
});
const AuditCreate = z.strictObject({
	areaId: z.uuid(),
	templateVersionId: z.uuid(),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	audience: z.enum(["private", "workspace"]).optional()
});
const AuditAccess = z.strictObject({
	revision: z.number().int().min(1),
	audience: z.enum(["private", "workspace"])
});
const Audit = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	areaId: z.uuid(),
	areaName: z.string().min(1).max(200),
	ownerId: z.uuid(),
	templateId: z.uuid(),
	templateVersionId: z.uuid(),
	state: z.enum([
		"draft",
		"submitted",
		"void"
	]),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	context: AuditContext,
	currentRevisionId: z.uuid().nullable(),
	score: Score,
	definition: TemplateDefinition,
	privacyRevision: z.number().int().min(0),
	access: AuditAccess,
	contextLocales: z.strictObject({
		department: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		additionalAuditors: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		highlight: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		mainConcern: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional()
	}),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const AnswerValue = z.union([
	z.number(),
	z.string().min(1).max(80),
	z.null()
]);
const AnswerUpdate = z.strictObject({
	expectedRevision: z.number().int().min(0),
	value: AnswerValue,
	notApplicable: z.boolean(),
	notApplicableReason: z.string().min(3).max(500).nullable()
});
const Answer = z.strictObject({
	questionKey: z.string().min(1).max(80),
	revision: z.number().int().min(1),
	value: AnswerValue,
	notApplicable: z.boolean(),
	notApplicableReason: z.string().min(3).max(500).nullable(),
	score: z.number().min(0).max(100).nullable()
});
const AuditMetadata = z.strictObject({
	expectedRevision: z.number().int().min(1),
	areaId: z.uuid(),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	context: AuditContext
});
const Submit = z.strictObject({
	expectedRevision: z.number().int().min(1),
	answerRevisions: z.record(z.string(), z.number().int().min(0)).refine((v) => Object.keys(v).length <= 200, "Too many entries")
});
const AuditRevision = z.strictObject({
	id: z.uuid(),
	auditId: z.uuid(),
	number: z.number().int().min(1),
	actorId: z.uuid(),
	reason: z.string().min(1).max(2e3).nullable(),
	submittedAt: z.iso.datetime({ offset: true }),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	areaName: z.string().min(1).max(200),
	context: AuditContext,
	auditors: z.array(z.strictObject({
		userId: z.uuid().nullable(),
		name: z.string().min(1).max(200)
	})).max(51),
	score: Score,
	definition: TemplateDefinition,
	answers: z.array(Answer).max(200),
	privacyRevision: z.number().int().min(0),
	privacyAdjusted: z.boolean()
});
const PreviousAuditQuery = z.strictObject({ referenceRevisionId: z.uuid().optional() });
const PreviousComparableAudit = z.strictObject({
	auditId: z.uuid().nullable(),
	revisionId: z.uuid().nullable(),
	effectiveAt: z.iso.datetime({ offset: true }).nullable(),
	score: Score.nullable(),
	delta: z.number().min(-100).max(100).nullable(),
	reason: z.enum([
		"found",
		"noPriorComparableAudit",
		"unscored"
	])
});
const RemarkCreate = z.strictObject({
	text: z.string().max(12e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	needsFollowUp: z.boolean().optional()
});
const Remark = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	questionKey: z.string().min(1).max(80),
	text: z.string().max(12e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	mediaIds: z.array(z.uuid()).max(25),
	findingId: z.uuid().nullable(),
	needsFollowUp: z.boolean()
});
const RemarkUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	text: z.string().max(12e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	needsFollowUp: z.boolean().optional()
});
const AuditSummary = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	areaId: z.uuid(),
	areaName: z.string().min(1).max(200),
	ownerId: z.uuid(),
	templateId: z.uuid(),
	templateVersionId: z.uuid(),
	state: z.enum([
		"draft",
		"submitted",
		"void"
	]),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	context: AuditContext,
	currentRevisionId: z.uuid().nullable(),
	score: Score,
	privacyRevision: z.number().int().min(0),
	access: AuditAccess,
	contextLocales: z.strictObject({
		department: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		additionalAuditors: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		highlight: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional(),
		mainConcern: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]).optional()
	}),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const AuditAccessUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	audience: z.enum(["private", "workspace"])
});
const AuditList = z.strictObject({
	items: z.array(Audit).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const AnswerList = z.strictObject({
	items: z.array(Answer).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const RemarkList = z.strictObject({
	items: z.array(Remark).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListAuditsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"draft",
		"submitted",
		"void"
	]).optional(),
	areaId: z.uuid().optional(),
	templateId: z.uuid().optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional(),
	minScore: z.coerce.number().min(0).max(100).optional(),
	maxScore: z.coerce.number().min(0).max(100).optional(),
	sort: z.enum(["createdAt", "effectiveAt"]).optional()
});
const ListAnswersQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListRemarksQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListRevisionRemarksQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const AuditSummaryList = z.strictObject({
	items: z.array(AuditSummary).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
// src/generated/findings.ts
var findings_exports = /* @__PURE__ */ __exportAll({
	Finding: () => Finding,
	FindingCreate: () => FindingCreate,
	FindingEvent: () => FindingEvent,
	FindingEventList: () => FindingEventList,
	FindingObservation: () => FindingObservation,
	FindingSummary: () => FindingSummary,
	FindingSummaryList: () => FindingSummaryList,
	FindingTransition: () => FindingTransition,
	FindingUpdate: () => FindingUpdate,
	ListFindingEventsQuery: () => ListFindingEventsQuery,
	ListFindingsQuery: () => ListFindingsQuery
});
const FindingCreate = z.strictObject({
	auditRevisionId: z.uuid(),
	questionKey: z.string().min(1).max(80),
	remarkIds: z.array(z.uuid()).max(100),
	title: z.string().min(1).max(300)
});
const Finding = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	auditId: z.uuid(),
	auditRevisionId: z.uuid(),
	questionKey: z.string().min(1).max(80),
	remarkIds: z.array(z.uuid()).max(100),
	title: z.string().min(1).max(300),
	ownerId: z.uuid(),
	collaboratorIds: z.array(z.uuid()).max(50),
	state: z.enum(["open", "fixed"]),
	sourceChanged: z.boolean(),
	titleLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const FindingSummary = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	auditId: z.uuid(),
	auditRevisionId: z.uuid(),
	questionKey: z.string().min(1).max(80),
	remarkIds: z.array(z.uuid()).max(100),
	title: z.string().min(1).max(300),
	ownerId: z.uuid(),
	collaboratorIds: z.array(z.uuid()).max(50),
	state: z.enum(["open", "fixed"]),
	sourceChanged: z.boolean(),
	areaId: z.uuid(),
	areaName: z.string().min(1).max(200),
	effectiveAt: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	remarkId: z.uuid().nullable(),
	remarkRevision: z.number().int().min(1).nullable(),
	remarkExcerpt: z.string().min(1).max(300).nullable(),
	remarkLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	evidenceCount: z.number().int().min(0),
	titleLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const FindingUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	title: z.string().min(1).max(300),
	ownerId: z.uuid(),
	collaboratorIds: z.array(z.uuid()).max(50)
});
const FindingTransition = z.strictObject({
	expectedRevision: z.number().int().min(1),
	state: z.enum(["open", "fixed"]),
	note: z.string().max(4e3),
	mediaIds: z.array(z.uuid()).max(25)
});
const FindingEvent = z.strictObject({
	id: z.uuid(),
	actorId: z.uuid(),
	state: z.enum(["open", "fixed"]),
	note: z.string().max(4e3),
	mediaIds: z.array(z.uuid()).max(25),
	createdAt: z.iso.datetime({ offset: true })
});
const FindingObservation = z.strictObject({
	expectedRevision: z.number().int().min(1),
	auditRevisionId: z.uuid(),
	questionKey: z.string().min(1).max(80),
	remarkIds: z.array(z.uuid()).max(100)
});
const FindingSummaryList = z.strictObject({
	items: z.array(FindingSummary).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const FindingEventList = z.strictObject({
	items: z.array(FindingEvent).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListFindingsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum(["open", "fixed"]).optional(),
	ownerId: z.uuid().optional(),
	areaId: z.uuid().optional(),
	sort: z.enum(["state", "createdAt"]).optional()
});
const ListFindingEventsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
// src/generated/media.ts
var media_exports = /* @__PURE__ */ __exportAll({
	Media: () => Media,
	MediaContentQuery: () => MediaContentQuery,
	UploadReservation: () => UploadReservation,
	UploadTicket: () => UploadTicket
});
const MediaContentQuery = z.strictObject({ variant: z.enum(["evidence", "thumbnail"]) });
const UploadReservation = z.strictObject({
	ownerType: z.enum([
		"remark",
		"finding",
		"branding",
		"audio",
		"analyticsPage"
	]),
	ownerId: z.uuid(),
	mime: z.enum([
		"image/jpeg",
		"image/png",
		"audio/webm",
		"audio/mp4",
		"audio/ogg",
		"audio/wav"
	]),
	bytes: z.number().int().min(1).max(10485760),
	thumbnailBytes: z.number().int().min(1).max(204800).optional()
});
const UploadTicket = z.strictObject({
	id: z.uuid(),
	uploadPath: z.string().min(1).max(1e3),
	expiresAt: z.iso.datetime({ offset: true }),
	maxBytes: z.number().int().min(0)
});
const Media = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	state: z.enum([
		"reserved",
		"uploaded",
		"processing",
		"ready",
		"failed",
		"deleted"
	]),
	mime: z.string().min(1).max(80),
	bytes: z.number().int().min(0),
	width: z.number().int().min(0).nullable(),
	height: z.number().int().min(0).nullable(),
	errorCode: z.string().min(1).max(80).nullable()
});
// src/generated/analytics.ts
var analytics_exports = /* @__PURE__ */ __exportAll({
	AnalyticsPage: () => AnalyticsPage,
	AnalyticsPageList: () => AnalyticsPageList,
	AppearanceStyle: () => AppearanceStyle,
	ChartPoint: () => ChartPoint,
	Filters: () => Filters,
	GridCell: () => GridCell,
	GridCellFreeform: () => GridCellFreeform,
	ListPagesQuery: () => ListPagesQuery,
	PageAccessUpdate: () => PageAccessUpdate,
	PageAppearance: () => PageAppearance,
	PageCreate: () => PageCreate,
	PageDefinition: () => PageDefinition,
	PagePrint: () => PagePrint,
	PageUpdate: () => PageUpdate,
	PageVersion: () => PageVersion,
	SeriesStyle: () => SeriesStyle,
	Widget: () => Widget,
	WidgetAnswerChange: () => WidgetAnswerChange,
	WidgetAreaRow: () => WidgetAreaRow,
	WidgetContent: () => WidgetContent,
	WidgetData: () => WidgetData,
	WidgetOptions: () => WidgetOptions,
	WidgetPresentation: () => WidgetPresentation,
	WidgetPreview: () => WidgetPreview,
	WidgetQuery: () => WidgetQuery,
	WidgetReportQuery: () => WidgetReportQuery
});
const Filters = z.strictObject({
	areaIds: z.array(z.uuid()).max(100).optional(),
	templateVersionId: z.uuid().optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional(),
	auditRevisionIds: z.array(z.uuid()).min(2).max(3).optional(),
	findingState: z.enum(["open", "fixed"]).optional(),
	ownerId: z.uuid().optional(),
	minScore: z.number().min(0).max(100).optional(),
	maxScore: z.number().min(0).max(100).optional(),
	auditStatus: z.enum([
		"draft",
		"submitted",
		"void"
	]).optional(),
	period: z.enum([
		"lastMonth",
		"last3Months",
		"last12Months",
		"allTime"
	]).optional()
});
const AppearanceStyle = z.strictObject({
	font: z.enum([
		"plexSans",
		"plexMono",
		"systemSans"
	]).optional(),
	titleFont: z.enum([
		"plexSans",
		"plexMono",
		"systemSans"
	]).optional(),
	fontSize: z.number().min(12).max(24).optional(),
	titleSize: z.number().min(12).max(48).optional(),
	valueSize: z.number().min(12).max(96).optional(),
	textColor: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).optional(),
	backgroundColor: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).optional(),
	borderColor: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).optional(),
	accentColor: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).optional(),
	padding: z.number().min(0).max(64).optional(),
	borderWidth: z.number().min(0).max(4).optional(),
	radius: z.number().min(0).max(32).optional(),
	shadow: z.enum([
		"none",
		"small",
		"medium"
	]).optional(),
	textAlign: z.enum([
		"left",
		"center",
		"right"
	]).optional(),
	backgroundMediaId: z.uuid().nullable().optional(),
	backgroundFit: z.enum(["cover", "contain"]).optional(),
	overlayColor: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).optional(),
	overlayOpacity: z.number().min(0).max(1).optional()
});
const PageAppearance = z.strictObject({
	style: AppearanceStyle,
	contentWidth: z.number().min(600).max(2400).nullable(),
	gutter: z.number().min(0).max(48),
	rowHeight: z.number().min(16).max(80),
	showTitle: z.boolean(),
	subtitle: z.string().max(1e3),
	titleAlign: z.enum([
		"left",
		"center",
		"right"
	])
});
const PagePrint = z.strictObject({
	paper: z.enum([
		"A4",
		"A3",
		"Letter"
	]),
	orientation: z.enum(["portrait", "landscape"]),
	marginMm: z.number().min(8).max(30),
	includeBackground: z.boolean(),
	showCompanyLogo: z.boolean()
});
const WidgetPresentation = z.strictObject({
	style: AppearanceStyle,
	showTitle: z.boolean(),
	subtitle: z.string().max(1e3),
	showSubtitle: z.boolean(),
	mobileHeight: z.number().min(120).max(1200),
	printIncluded: z.boolean(),
	printBreakBefore: z.boolean()
});
const SeriesStyle = z.strictObject({
	key: z.string().min(1).max(120),
	label: z.string().min(1).max(200).nullable(),
	color: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")),
	lineWidth: z.number().min(0).max(8),
	lineStyle: z.enum([
		"solid",
		"dashed",
		"dotted"
	]),
	marker: z.enum([
		"none",
		"circle",
		"square",
		"diamond",
		"triangle"
	]),
	markerSize: z.number().min(2).max(20),
	fillOpacity: z.number().min(0).max(1),
	visible: z.boolean()
});
const WidgetOptions = z.strictObject({
	variant: z.enum([
		"metric",
		"radar",
		"groupedBars",
		"line",
		"area",
		"bars",
		"table",
		"grid",
		"text",
		"image",
		"columns",
		"stacked"
	]).optional(),
	showLegend: z.boolean().optional(),
	legendPosition: z.enum([
		"top",
		"bottom",
		"left",
		"right"
	]).optional(),
	showValues: z.boolean().optional(),
	showGrid: z.boolean().optional(),
	showAxisLabels: z.boolean().optional(),
	axisLabelAngle: z.number().min(-90).max(90).optional(),
	orientation: z.enum(["horizontal", "vertical"]).optional(),
	decimals: z.number().int().min(0).max(3).optional(),
	series: z.array(SeriesStyle).max(20).optional(),
	categoryKeys: z.array(z.string().min(1).max(80)).max(20).optional(),
	columns: z.array(z.enum([
		"criterion",
		"remark",
		"state",
		"area",
		"effectiveAt",
		"score",
		"owner",
		"template",
		"photos"
	])).max(12).optional(),
	sortBy: z.enum([
		"criterion",
		"remark",
		"state",
		"area",
		"effectiveAt",
		"score",
		"owner",
		"template",
		"photos"
	]).optional(),
	sortDirection: z.enum(["asc", "desc"]).optional(),
	density: z.enum([
		"compact",
		"normal",
		"comfortable"
	]).optional(),
	wrapText: z.boolean().optional(),
	showThumbnails: z.boolean().optional(),
	galleryColumns: z.number().int().min(1).max(8).optional(),
	aspectRatio: z.enum([
		"square",
		"landscape",
		"portrait",
		"original"
	]).optional(),
	imageFit: z.enum(["contain", "cover"]).optional(),
	showCaptions: z.boolean().optional(),
	maxImages: z.number().int().min(1).max(100).optional(),
	sampleCountPosition: z.enum([
		"above",
		"below",
		"inline"
	]).optional(),
	metric: z.enum([
		"averageScore",
		"auditsCompleted",
		"openFindings",
		"openOlderThan",
		"findingsOpened",
		"findingsFixed",
		"weakestCategory"
	]).optional(),
	comparePrevious: z.boolean().optional(),
	olderThanDays: z.number().int().min(1).max(365).optional(),
	stackBy: z.enum(["none", "area"]).optional(),
	groupBy: z.enum([
		"category",
		"area",
		"age"
	]).optional(),
	showPercent: z.boolean().optional(),
	topCount: z.number().int().min(1).max(20).optional(),
	changeFilter: z.enum([
		"declined",
		"improved",
		"both"
	]).optional(),
	expandQuestions: z.boolean().optional(),
	textStyle: z.enum(["heading", "note"]).optional()
});
const WidgetContent = z.discriminatedUnion("kind", [z.strictObject({
	kind: z.literal("text"),
	text: z.string().max(4e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	])
}), z.strictObject({
	kind: z.literal("image"),
	mediaId: z.uuid(),
	alt: z.string().min(1).max(1e3),
	caption: z.string().max(1e3),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	])
})]);
const Widget = z.strictObject({
	id: z.uuid(),
	type: z.enum([
		"scoreSummary",
		"categoryComparison",
		"scoreTrend",
		"categoryBars",
		"remarks",
		"gallery",
		"auditList",
		"text",
		"image",
		"keyFigure",
		"auditCount",
		"findingsFlow",
		"areaRanking",
		"areaCategoryMatrix",
		"comparisonTable",
		"changedAnswers",
		"topChanges",
		"answerDistribution",
		"deficiencyPareto",
		"findingsBreakdown",
		"areaStatus",
		"repeatDeficiencies"
	]),
	title: z.string().min(1).max(200),
	filters: Filters,
	aggregation: z.enum([
		"latest",
		"mean",
		"count"
	]),
	bucket: z.enum([
		"day",
		"week",
		"month"
	]),
	printSize: z.enum([
		"quarter",
		"third",
		"half",
		"full"
	]),
	presentation: WidgetPresentation,
	options: WidgetOptions,
	content: WidgetContent.nullable()
});
const GridCell = z.strictObject({
	widgetId: z.uuid(),
	x: z.number().int().min(0),
	y: z.number().int().min(0),
	w: z.number().int().min(1).max(12),
	h: z.number().int().min(1).max(30)
});
const GridCellFreeform = z.strictObject({
	widgetId: z.uuid(),
	x: z.number().int().min(0),
	y: z.number().int().min(0),
	w: z.number().int().min(1).max(48),
	h: z.number().int().min(1).max(120)
});
const PageDefinition = z.strictObject({
	name: z.string().min(1).max(200),
	sourceLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	filters: Filters,
	appearance: PageAppearance,
	print: PagePrint,
	widgets: z.array(Widget).max(30),
	desktop: z.array(GridCell).max(30),
	tablet: z.array(GridCell).max(30),
	mobileOrder: z.array(z.uuid()).max(30),
	printOrder: z.array(z.uuid()).max(30),
	layout: z.enum(["grid", "freeform"]).optional(),
	freeform: z.array(GridCellFreeform).max(30).optional()
});
const AnalyticsPage = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	publishedVersionId: z.uuid().nullable(),
	draft: PageDefinition.nullable(),
	ownerId: z.uuid(),
	audience: z.enum(["private", "workspace"]),
	nameLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const PageCreate = z.strictObject({
	definition: PageDefinition,
	audience: z.enum(["private", "workspace"]).optional()
});
const PageUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	definition: PageDefinition
});
const PageVersion = z.strictObject({
	id: z.uuid(),
	pageId: z.uuid(),
	number: z.number().int().min(1),
	definition: PageDefinition,
	publishedAt: z.iso.datetime({ offset: true }),
	privacyRevision: z.number().int().min(0),
	pagePublicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const WidgetQuery = z.strictObject({
	pageVersionId: z.uuid(),
	widgetId: z.uuid(),
	filters: Filters,
	cursor: z.string().min(1).max(1024).optional(),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional()
});
const WidgetPreview = z.strictObject({
	definition: PageDefinition,
	widgetId: z.uuid(),
	filters: Filters,
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional()
});
const ChartPoint = z.strictObject({
	key: z.string().min(1).max(120),
	label: z.string().min(1).max(300),
	value: z.number().nullable(),
	sampleCount: z.number().int().min(0)
});
const WidgetAreaRow = z.strictObject({
	areaId: z.uuid(),
	areaName: z.string().min(1).max(200),
	auditCount: z.number().int().min(0),
	lastAuditAt: z.iso.datetime({ offset: true }).nullable(),
	lastScore: z.number().min(0).max(100).nullable(),
	previousScore: z.number().min(0).max(100).nullable(),
	scoringSignature: z.string().min(1).max(64).nullable(),
	openFindings: z.number().int().min(0),
	daysSinceLast: z.number().int().min(0).nullable()
});
const WidgetAnswerChange = z.strictObject({
	questionKey: z.string().min(1).max(80),
	categoryKey: z.string().min(1).max(80),
	questionTitle: z.string().min(1).max(500),
	categoryTitle: z.string().min(1).max(200),
	beforeState: z.enum([
		"answered",
		"notApplicable",
		"unanswered"
	]),
	afterState: z.enum([
		"answered",
		"notApplicable",
		"unanswered"
	]),
	beforeLabel: z.string().min(1).max(300).nullable(),
	afterLabel: z.string().min(1).max(300).nullable(),
	beforeScore: z.number().min(0).max(100).nullable(),
	afterScore: z.number().min(0).max(100).nullable(),
	remark: z.string().min(1).max(300).nullable(),
	mediaIds: z.array(z.uuid()).max(4)
});
const WidgetData = z.strictObject({
	widgetId: z.uuid(),
	asOf: z.iso.datetime({ offset: true }),
	timezone: z.string().min(1).max(80),
	scoringSignature: z.string().min(1).max(64).nullable(),
	compatible: z.boolean(),
	series: z.array(z.strictObject({
		key: z.string().min(1).max(120),
		label: z.string().min(1).max(300),
		points: z.array(ChartPoint).max(500)
	})).max(20),
	findings: z.array(Finding).max(50),
	remarks: z.array(Remark).max(50),
	audits: z.array(AuditSummary).max(50),
	media: z.array(Media).max(50),
	nextCursor: z.string().min(1).max(1024).nullable(),
	areaRows: z.array(WidgetAreaRow).max(200),
	answerChanges: z.array(WidgetAnswerChange).max(100)
});
const PageAccessUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	audience: z.enum(["private", "workspace"])
});
const AnalyticsPageList = z.strictObject({
	items: z.array(AnalyticsPage).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListPagesQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional()
});
const WidgetReportQuery = z.strictObject({
	widgetId: z.uuid(),
	filters: Filters,
	cursor: z.string().min(1).max(1024).optional(),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional()
});
// src/generated/ai.ts
var ai_exports = /* @__PURE__ */ __exportAll({
	AiCreate: () => AiCreate,
	AiDashboardSuggestion: () => AiDashboardSuggestion,
	AiQuestionContext: () => AiQuestionContext,
	AiQuestionContextQuery: () => AiQuestionContextQuery,
	AiQuestionSuggestion: () => AiQuestionSuggestion,
	AiResult: () => AiResult,
	AiTemplateImport: () => AiTemplateImport,
	TemplateBrief: () => TemplateBrief
});
const TemplateBrief = z.strictObject({
	purpose: z.string().min(1).max(1e3),
	process: z.string().min(1).max(1e3),
	audience: z.string().max(500),
	includedTopics: z.string().max(2e3),
	excludedTopics: z.string().max(2e3),
	targetQuestions: z.number().int().min(1).max(200),
	targetCategories: z.number().int().min(1).max(20),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	displayMaximum: z.union([z.literal(10), z.literal(100)]),
	scoringMode: z.enum(["observationChoices", "numericMeasurements"]),
	scoringGuidance: z.string().max(3e3),
	criticalConditions: z.string().max(1e3),
	applicabilityGuidance: z.string().max(1e3),
	evidenceGuidance: z.string().max(1e3)
});
const AiCreate = z.strictObject({
	feature: z.enum([
		"template",
		"rewrite",
		"voice"
	]),
	sourceId: z.uuid().nullable(),
	sourceRevision: z.number().int().min(1).nullable(),
	sourceHash: z.string().min(1).max(64).nullable(),
	text: z.string().max(12e3),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	audioMediaId: z.uuid().nullable(),
	instruction: z.string().max(2e3),
	priorTaskId: z.uuid().nullable(),
	templateBrief: TemplateBrief.optional(),
	speechLanguage: z.enum([
		"auto",
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).optional(),
	dictationId: z.uuid().nullable().optional()
});
const AiResult = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	feature: z.enum([
		"template",
		"rewrite",
		"voice",
		"import",
		"questions",
		"dashboard"
	]),
	state: z.enum([
		"queued",
		"running",
		"ready",
		"failed",
		"cancelled"
	]),
	text: z.string().max(16e3).nullable(),
	definition: TemplateDefinition.nullable(),
	sourceHash: z.string().min(1).max(64).nullable(),
	model: z.string().min(1).max(200),
	promptVersion: z.string().min(1).max(80),
	detectedLocale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]).nullable(),
	errorCode: z.enum([
		"invalidInput",
		"featureDisabled",
		"providerUnavailable",
		"rateLimited",
		"invalidOutput",
		"validationFailed",
		"mediaMissing",
		"unreadableDocument",
		"documentTooLarge",
		"noQuestionsFound",
		"sourceChanged"
	]).nullable(),
	transcript: z.string().max(16e3).nullable(),
	questions: z.array(Question).max(10).nullable(),
	page: PageDefinition.nullable(),
	templateId: z.uuid().nullable(),
	areaNames: z.array(z.string().min(1).max(200)).max(50),
	notices: z.array(z.enum(["skippedRows", "ignoredInstructions"])).max(2)
});
const AiTemplateImport = z.strictObject({
	format: z.enum(["csv", "pdf"]),
	fileName: z.string().min(1).max(200),
	content: z.string().min(1).max(2e6),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	])
});
const AiQuestionSuggestion = z.strictObject({
	templateId: z.uuid(),
	expectedRevision: z.number().int().min(1),
	categoryKey: z.string().min(1).max(80),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	focus: z.array(z.enum([
		"unneededItems",
		"missingOrMisplaced",
		"dirtLeaksWaste",
		"labelsMarkings",
		"blockedSafety",
		"damagedEquipment",
		"rulesNotFollowed",
		"basics"
	])).min(1).max(3),
	count: z.union([
		z.literal(3),
		z.literal(5),
		z.literal(8),
		z.literal(10)
	]),
	workplace: z.enum([
		"office",
		"production",
		"warehouse",
		"workshop",
		"laboratory",
		"outdoor",
		"other"
	]).nullable(),
	workplaceOther: z.string().max(80),
	note: z.string().max(300)
});
const AiQuestionContextQuery = z.strictObject({
	templateId: z.uuid(),
	categoryKey: z.string().min(1).max(80)
});
const AiQuestionContext = z.strictObject({
	workplace: z.enum([
		"office",
		"production",
		"warehouse",
		"workshop",
		"laboratory",
		"outdoor",
		"other"
	]).nullable(),
	defaultCount: z.union([
		z.literal(3),
		z.literal(5),
		z.literal(8),
		z.literal(10)
	]),
	existingQuestions: z.number().int().min(0),
	remainingQuestions: z.number().int().min(0)
});
const AiDashboardSuggestion = z.strictObject({
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	name: z.string().max(200),
	goals: z.array(z.enum([
		"overallLevel",
		"compareAreas",
		"trend",
		"findingsFollowUp",
		"recurringProblems",
		"auditChanges"
	])).max(2),
	audience: z.enum([
		"team",
		"management",
		"justMe"
	]),
	areaIds: z.array(z.uuid()).max(100),
	period: z.enum([
		"lastMonth",
		"last3Months",
		"last12Months",
		"allTime"
	]),
	templateVersionId: z.uuid().nullable(),
	note: z.string().max(1e3),
	existingEntries: z.array(z.string().min(1).max(80)).max(40)
});
// src/generated/billing.ts
var billing_exports = /* @__PURE__ */ __exportAll({
	Agreement: () => Agreement,
	AgreementChange: () => AgreementChange,
	AgreementConfirm: () => AgreementConfirm,
	AgreementPreview: () => AgreementPreview,
	AgreementTerms: () => AgreementTerms,
	AgreementVersion: () => AgreementVersion,
	AgreementVersionList: () => AgreementVersionList,
	AllowanceResetPurchase: () => AllowanceResetPurchase,
	AllowanceUsage: () => AllowanceUsage,
	BillingDetails: () => BillingDetails,
	BillingDetailsUpdate: () => BillingDetailsUpdate,
	BillingInvoice: () => BillingInvoice,
	BillingOverview: () => BillingOverview,
	BillingPortal: () => BillingPortal,
	BrandAccent: () => BrandAccent,
	ListAgreementVersionsQuery: () => ListAgreementVersionsQuery,
	ListPlansQuery: () => ListPlansQuery,
	Money: () => Money,
	Plan: () => Plan,
	PlanAllowances: () => PlanAllowances,
	PlanCapability: () => PlanCapability,
	PlanInput: () => PlanInput,
	PlanList: () => PlanList,
	PlanTerms: () => PlanTerms,
	PlanUpdate: () => PlanUpdate,
	RecurringCost: () => RecurringCost,
	ResetOffer: () => ResetOffer,
	SidebarBranding: () => SidebarBranding,
	WhiteLabel: () => WhiteLabel
});
const WhiteLabel = z.strictObject({
	enabled: z.boolean(),
	sidebarName: z.string().min(1).max(60).nullable(),
	lightAccent: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).nullable(),
	darkAccent: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")).nullable(),
	darkLogoMediaId: z.uuid().nullable()
});
const PlanAllowances = z.strictObject({
	voice: z.number().int().min(0).max(1e7),
	rewrite: z.number().int().min(0).max(1e7),
	template: z.number().int().min(0).max(1e7),
	import: z.number().int().min(0).max(1e7),
	questions: z.number().int().min(0).max(1e7),
	dashboard: z.number().int().min(0).max(1e7)
});
const AllowanceUsage = z.strictObject({
	key: z.enum([
		"voice",
		"rewrite",
		"template",
		"import",
		"questions",
		"dashboard"
	]),
	limit: z.number().int().min(0).max(1e7),
	granted: z.number().int().min(0).max(1e7),
	used: z.number().int().min(0).max(1e7),
	reserved: z.number().int().min(0).max(1e7)
});
const PlanCapability = z.strictObject({
	key: z.enum([
		"whiteLabel",
		"ai.voice",
		"ai.rewrite",
		"ai.template",
		"ai.import",
		"ai.questions",
		"ai.dashboard"
	]),
	unitAmount: z.number().int().min(0).max(1e8)
});
const AgreementTerms = z.strictObject({
	planName: z.string().min(1).max(120),
	memberUnitAmount: z.number().int().min(0).max(1e8),
	agreedMembers: z.number().int().min(1).max(1e5),
	storageGb: z.number().int().min(1).max(1e5),
	imageLimit: z.number().int().min(1).max(1e7),
	allowances: PlanAllowances,
	capabilities: z.array(PlanCapability).max(7),
	resetUnitAmount: z.number().int().min(0).max(1e8)
});
const BillingDetails = z.strictObject({
	legalName: z.string().min(1).max(200),
	email: z.email(),
	country: z.string().min(2).max(2).regex(/* @__PURE__ */ new RegExp("^[A-Z]{2}$")),
	vatId: z.string().min(4).max(20).regex(/* @__PURE__ */ new RegExp("^[A-Z]{2}[A-Za-z0-9]{2,18}$")).nullable(),
	collection: z.enum(["automatic", "invoice"]),
	daysUntilDue: z.number().int().min(7).max(60)
});
const PlanTerms = z.strictObject({
	memberUnitAmount: z.number().int().min(0).max(1e8),
	agreedMembers: z.number().int().min(1).max(1e5),
	storageGb: z.number().int().min(1).max(1e5),
	imageLimit: z.number().int().min(1).max(1e7),
	allowances: PlanAllowances,
	capabilities: z.array(PlanCapability).max(7),
	resetUnitAmount: z.number().int().min(0).max(1e8)
});
const Plan = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	name: z.string().min(1).max(120),
	freeFirstMonth: z.boolean(),
	terms: PlanTerms,
	assignedOrganizations: z.number().int().min(0),
	createdAt: z.iso.datetime({ offset: true }),
	updatedAt: z.iso.datetime({ offset: true })
});
const PlanInput = z.strictObject({
	name: z.string().min(1).max(120),
	freeFirstMonth: z.boolean(),
	terms: PlanTerms
});
const PlanUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	name: z.string().min(1).max(120),
	freeFirstMonth: z.boolean(),
	terms: PlanTerms
});
const BillingDetailsUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	billing: BillingDetails,
	reason: z.string().min(10).max(2e3)
});
const Money = z.strictObject({
	net: z.number().int().min(-1e8).max(1e8),
	tax: z.number().int().min(-1e8).max(1e8),
	gross: z.number().int().min(-1e8).max(1e8)
});
const RecurringCost = z.strictObject({
	interval: z.enum(["month", "year"]),
	memberNet: z.number().int().min(0).max(1e8),
	addonsNet: z.number().int().min(0).max(1e8),
	net: z.number().int().min(0).max(1e8),
	tax: z.number().int().min(0).max(1e8),
	gross: z.number().int().min(0).max(1e8),
	vatRateBasisPoints: z.number().int().min(0).max(1e4),
	vatTreatment: z.enum([
		"domestic",
		"reverseCharge",
		"notTaxable",
		"unknown"
	])
});
const Agreement = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	organizationId: z.uuid(),
	planId: z.uuid().nullable(),
	terms: AgreementTerms,
	billing: BillingDetails.nullable(),
	recurring: RecurringCost,
	status: z.enum([
		"notConnected",
		"pending",
		"trialing",
		"active",
		"pastDue",
		"unpaid",
		"paused",
		"canceled"
	]),
	syncState: z.enum([
		"ok",
		"pending",
		"failed",
		"drift"
	]),
	trialEndsAt: z.iso.datetime({ offset: true }).nullable(),
	currentPeriodStart: z.iso.datetime({ offset: true }).nullable(),
	currentPeriodEnd: z.iso.datetime({ offset: true }).nullable(),
	paymentMethod: z.string().min(1).max(120).nullable(),
	scheduled: z.strictObject({
		versionId: z.uuid(),
		effectiveAt: z.iso.datetime({ offset: true }),
		terms: AgreementTerms,
		recurring: RecurringCost
	}).nullable(),
	stripe: z.strictObject({
		customerId: z.string().min(1).max(255).nullable(),
		subscriptionId: z.string().min(1).max(255).nullable(),
		scheduleId: z.string().min(1).max(255).nullable()
	}).nullable(),
	updatedAt: z.iso.datetime({ offset: true })
});
const AgreementChange = z.strictObject({
	expectedRevision: z.number().int().min(1),
	terms: AgreementTerms,
	timing: z.enum(["now", "nextPeriod"]).optional()
});
const AgreementPreview = z.strictObject({
	versionId: z.uuid(),
	previewHash: z.string().min(64).max(64),
	expiresAt: z.iso.datetime({ offset: true }),
	timing: z.enum(["now", "nextPeriod"]),
	effectiveAt: z.iso.datetime({ offset: true }),
	terms: AgreementTerms,
	current: RecurringCost,
	next: RecurringCost,
	dueNow: Money,
	prorationDate: z.iso.datetime({ offset: true }).nullable(),
	nextInvoiceAt: z.iso.datetime({ offset: true }).nullable(),
	trialEndsAt: z.iso.datetime({ offset: true }).nullable(),
	payment: z.enum([
		"automatic",
		"invoice",
		"notConnected"
	]),
	paymentMethod: z.string().min(1).max(120).nullable(),
	source: z.enum(["stripe", "estimate"]),
	notes: z.array(z.enum([
		"trial",
		"creditNextInvoice",
		"decreaseAtPeriodEnd",
		"noFinancialChange",
		"notConnected",
		"decreaseNow"
	])).max(6)
});
const AgreementConfirm = z.strictObject({
	versionId: z.uuid(),
	previewHash: z.string().min(64).max(64),
	expectedRevision: z.number().int().min(1),
	reason: z.string().min(10).max(2e3)
});
const AgreementVersion = z.strictObject({
	id: z.uuid(),
	version: z.number().int().min(1),
	status: z.enum([
		"previewed",
		"applied",
		"scheduled",
		"failed",
		"discarded"
	]),
	timing: z.enum(["now", "nextPeriod"]),
	effectiveAt: z.iso.datetime({ offset: true }),
	terms: AgreementTerms,
	recurring: RecurringCost,
	dueNow: Money.nullable(),
	reason: z.string().min(1).max(2e3).nullable(),
	createdAt: z.iso.datetime({ offset: true }),
	appliedAt: z.iso.datetime({ offset: true }).nullable()
});
const BillingInvoice = z.strictObject({
	id: z.string().min(1).max(255),
	number: z.string().min(1).max(100).nullable(),
	status: z.enum([
		"draft",
		"open",
		"paid",
		"uncollectible",
		"void"
	]),
	kind: z.enum([
		"subscription",
		"reset",
		"other"
	]),
	total: z.number().int().min(-1e8).max(1e8),
	amountDue: z.number().int().min(0).max(1e8),
	amountPaid: z.number().int().min(0).max(1e8),
	currency: z.string().min(3).max(3),
	createdAt: z.iso.datetime({ offset: true }),
	dueAt: z.iso.datetime({ offset: true }).nullable(),
	hostedUrl: z.string().min(1).max(2e3).nullable()
});
const AllowanceResetPurchase = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	period: z.string().min(7).max(7),
	state: z.enum([
		"open",
		"awaitingFunds",
		"paid",
		"fulfilled",
		"expired",
		"failed",
		"voided"
	]),
	method: z.enum(["checkout", "invoice"]),
	amount: Money,
	paymentUrl: z.string().min(1).max(2e3).nullable(),
	createdAt: z.iso.datetime({ offset: true }),
	paidAt: z.iso.datetime({ offset: true }).nullable(),
	fulfilledAt: z.iso.datetime({ offset: true }).nullable()
});
const ResetOffer = z.strictObject({
	available: z.boolean(),
	reason: z.enum([
		"notConnected",
		"noAllowances",
		"nothingUsed",
		"contractInactive",
		"purchaseOpen",
		"priceMissing"
	]).nullable(),
	method: z.enum(["checkout", "invoice"]).nullable(),
	price: Money,
	period: z.string().min(7).max(7),
	restores: z.array(z.enum([
		"voice",
		"rewrite",
		"template",
		"import",
		"questions",
		"dashboard"
	])).max(6),
	purchases: z.array(AllowanceResetPurchase).max(10)
});
const BillingOverview = z.strictObject({
	agreement: Agreement,
	reset: ResetOffer,
	invoices: z.array(BillingInvoice).max(24)
});
const BillingPortal = z.strictObject({ url: z.string().min(1).max(2e3) });
const BrandAccent = z.strictObject({
	indicator: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")),
	text: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")),
	subtle: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")),
	surface: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$")),
	hover: z.string().min(7).max(7).regex(/* @__PURE__ */ new RegExp("^#[0-9A-Fa-f]{6}$"))
});
const SidebarBranding = z.strictObject({
	enabled: z.boolean(),
	name: z.string().min(1).max(60).nullable(),
	logoMediaId: z.uuid().nullable(),
	darkLogoMediaId: z.uuid().nullable(),
	light: BrandAccent.nullable(),
	dark: BrandAccent.nullable()
});
const PlanList = z.strictObject({
	items: z.array(Plan).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const AgreementVersionList = z.strictObject({
	items: z.array(AgreementVersion).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListPlansQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
const ListAgreementVersionsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional()
});
// src/generated/exports.ts
var exports_exports = /* @__PURE__ */ __exportAll({ Job: () => Job });
const Job = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	kind: z.enum([
		"mail",
		"dataExport",
		"ai",
		"deletion",
		"billing",
		"security"
	]),
	state: z.enum([
		"queued",
		"running",
		"succeeded",
		"failed",
		"cancelled"
	]),
	attempts: z.number().int().min(0),
	createdAt: z.iso.datetime({ offset: true }),
	resultId: z.uuid().nullable(),
	errorCode: z.string().min(1).max(80).nullable()
});
// src/generated/organization.ts
var organization_exports = /* @__PURE__ */ __exportAll({
	Branding: () => Branding,
	BrandingUpdate: () => BrandingUpdate,
	DeleteOrganization: () => DeleteOrganization,
	Entitlement: () => Entitlement,
	EntitlementUpdate: () => EntitlementUpdate,
	FeatureGrant: () => FeatureGrant,
	Grant: () => Grant,
	Invitation: () => Invitation,
	InvitationList: () => InvitationList,
	InvitationPreview: () => InvitationPreview,
	Invite: () => Invite,
	ListActivityQuery: () => ListActivityQuery,
	ListInvitationsQuery: () => ListInvitationsQuery,
	ListMembersQuery: () => ListMembersQuery,
	ListWorkspacePeopleQuery: () => ListWorkspacePeopleQuery,
	ListWorkspacesQuery: () => ListWorkspacesQuery,
	Member: () => Member,
	MemberList: () => MemberList,
	MemberUpdate: () => MemberUpdate,
	Organization: () => Organization,
	OrganizationPrivacyNotice: () => OrganizationPrivacyNotice,
	OrganizationPrivacyUpdate: () => OrganizationPrivacyUpdate,
	OrganizationUpdate: () => OrganizationUpdate,
	RemovalConfirm: () => RemovalConfirm,
	RemovalPlan: () => RemovalPlan,
	RemovalSelection: () => RemovalSelection,
	Retention: () => Retention,
	RetentionUpdate: () => RetentionUpdate,
	SecurityEvent: () => SecurityEvent,
	SecurityEventList: () => SecurityEventList,
	SecurityPolicy: () => SecurityPolicy,
	SecurityPolicyUpdate: () => SecurityPolicyUpdate,
	ToolAccess: () => ToolAccess,
	Usage: () => Usage,
	Workspace: () => Workspace,
	WorkspaceList: () => WorkspaceList,
	WorkspacePerson: () => WorkspacePerson,
	WorkspacePersonList: () => WorkspacePersonList,
	WorkspaceUpdate: () => WorkspaceUpdate
});
const InvitationPreview = z.strictObject({
	state: z.enum([
		"pending",
		"accepted",
		"expired",
		"revoked"
	]),
	organizationName: z.string().min(1).max(200).nullable(),
	email: z.email().nullable(),
	organizationRole: z.enum(["administrator", "member"]).nullable(),
	workspaces: z.array(z.strictObject({
		name: z.string().min(1).max(200),
		role: z.enum([
			"administrator",
			"consultant",
			"viewer"
		])
	})).max(100),
	expiresAt: z.iso.datetime({ offset: true }).nullable(),
	existingAccount: z.boolean()
});
const Organization = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	timezone: z.string().min(1).max(80),
	status: z.enum([
		"pending",
		"active",
		"grace",
		"suspended",
		"deleting"
	]),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const OrganizationUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	timezone: z.string().min(1).max(80)
});
const Workspace = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	organizationId: z.uuid(),
	name: z.string().min(1).max(200),
	timezone: z.string().min(1).max(80),
	retired: z.boolean(),
	publicId: z.string().min(11).max(11).regex(/* @__PURE__ */ new RegExp("^[0-9A-Za-z]{11}$"))
});
const WorkspaceUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	name: z.string().min(1).max(200),
	timezone: z.string().min(1).max(80),
	retired: z.boolean()
});
const Grant = z.strictObject({
	workspaceId: z.uuid(),
	role: z.enum([
		"administrator",
		"consultant",
		"viewer"
	])
});
const WorkspacePerson = z.strictObject({
	userId: z.uuid(),
	name: z.string().min(1).max(200),
	role: z.enum([
		"administrator",
		"consultant",
		"viewer"
	])
});
const Member = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	userId: z.uuid(),
	email: z.email(),
	name: z.string().min(1).max(200),
	organizationRole: z.enum(["administrator", "member"]),
	grants: z.array(Grant).max(100),
	status: z.enum([
		"invited",
		"active",
		"removed"
	])
});
const Invite = z.strictObject({
	email: z.email(),
	organizationRole: z.enum(["administrator", "member"]),
	grants: z.array(Grant).max(100)
});
const MemberUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	organizationRole: z.enum(["administrator", "member"]),
	grants: z.array(Grant).max(100)
});
const Invitation = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	email: z.email(),
	expiresAt: z.iso.datetime({ offset: true }),
	state: z.enum([
		"pending",
		"accepted",
		"expired",
		"revoked"
	]),
	deliveryState: z.enum([
		"queued",
		"sent",
		"failed"
	])
});
const Branding = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	logoMediaId: z.uuid().nullable(),
	whiteLabelAvailable: z.boolean(),
	whiteLabel: WhiteLabel
});
const BrandingUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	logoMediaId: z.uuid().nullable(),
	whiteLabel: WhiteLabel
});
const SecurityPolicy = z.strictObject({
	revision: z.number().int().min(1),
	requireMfa: z.boolean()
});
const SecurityPolicyUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	requireMfa: z.boolean()
});
const OrganizationPrivacyNotice = z.strictObject({
	revision: z.number().int().min(1),
	contactEmail: z.email().nullable(),
	notices: z.array(z.strictObject({
		locale: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]),
		text: z.string().min(50).max(12e3)
	})).max(5),
	publishedAt: z.iso.datetime({ offset: true }).nullable()
});
const OrganizationPrivacyUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	contactEmail: z.email(),
	notices: z.array(z.strictObject({
		locale: z.enum([
			"en",
			"de",
			"es",
			"fr",
			"tr"
		]),
		text: z.string().min(50).max(12e3)
	})).min(1).max(5)
});
const Retention = z.strictObject({
	revision: z.number().int().min(1),
	evidenceMonths: z.number().int().min(1).max(120),
	legalHold: z.boolean()
});
const RetentionUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	evidenceMonths: z.number().int().min(1).max(120),
	reason: z.string().min(10).max(2e3)
});
const FeatureGrant = z.strictObject({
	key: z.enum([
		"tool.5s",
		"ai.template",
		"ai.voice",
		"ai.rewrite",
		"ai.import",
		"ai.questions",
		"ai.dashboard",
		"whiteLabel"
	]),
	enabled: z.boolean(),
	source: z.enum([
		"included",
		"addon",
		"manual"
	])
});
const Entitlement = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	planKey: z.string().min(1).max(80),
	currency: z.string().min(3).max(3),
	periodStart: z.iso.date(),
	periodEnd: z.iso.date(),
	state: z.enum([
		"pending",
		"active",
		"grace",
		"suspended"
	]),
	limits: z.strictObject({
		users: z.number().int().min(0),
		workspaces: z.number().int().min(0),
		storageBytes: z.number().int().min(0),
		images: z.number().int().min(0)
	}),
	agreementReference: z.string().min(1).max(200).nullable(),
	invoiceReference: z.string().min(1).max(200).nullable(),
	features: z.array(FeatureGrant).max(10),
	terminatedAt: z.iso.datetime({ offset: true }).nullable(),
	purgeAt: z.iso.datetime({ offset: true }).nullable(),
	allowances: PlanAllowances
});
const EntitlementUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	periodStart: z.iso.date(),
	periodEnd: z.iso.date(),
	state: z.enum([
		"pending",
		"active",
		"grace",
		"suspended"
	]),
	agreementReference: z.string().min(1).max(200).nullable(),
	invoiceReference: z.string().min(1).max(200).nullable(),
	reason: z.string().min(10).max(2e3),
	terminatedAt: z.iso.datetime({ offset: true }).nullable(),
	purgeAt: z.iso.datetime({ offset: true }).nullable()
});
const ToolAccess = z.strictObject({
	tools: z.array(z.strictObject({
		key: z.enum(["5s"]),
		name: z.string().min(1).max(100),
		enabled: z.boolean()
	})).max(1),
	aiFeatures: z.array(z.enum([
		"template",
		"rewrite",
		"voice",
		"import",
		"questions",
		"dashboard"
	])).max(6),
	whiteLabel: z.boolean(),
	capabilities: z.array(z.enum([
		"whiteLabel",
		"ai.voice",
		"ai.rewrite",
		"ai.template",
		"ai.import",
		"ai.questions",
		"ai.dashboard"
	])).max(7),
	exhaustedAllowances: z.array(z.enum([
		"voice",
		"rewrite",
		"template",
		"import",
		"questions",
		"dashboard"
	])).max(6)
});
const Usage = z.strictObject({
	users: z.number().int().min(0),
	reservedUsers: z.number().int().min(0),
	workspaces: z.number().int().min(0),
	storageBytes: z.number().int().min(0),
	reservedStorageBytes: z.number().int().min(0),
	asOf: z.iso.datetime({ offset: true }),
	allowances: z.array(AllowanceUsage).max(6),
	imageCount: z.number().int().min(0)
});
const SecurityEvent = z.strictObject({
	id: z.uuid(),
	actorId: z.uuid(),
	action: z.string().min(1).max(100),
	targetId: z.uuid().nullable(),
	reason: z.string().min(1).max(2e3).nullable(),
	createdAt: z.iso.datetime({ offset: true }),
	hltSupport: z.boolean()
});
const DeleteOrganization = z.strictObject({
	expectedRevision: z.number().int().min(1),
	confirmedName: z.string().min(1).max(200),
	reason: z.string().min(10).max(2e3)
});
const RemovalSelection = z.strictObject({
	expectedRevision: z.number().int().min(1),
	mode: z.enum([
		"deleteOwned",
		"transferSelected",
		"transferAll"
	]),
	targetUserId: z.uuid().nullable(),
	selectedAuditIds: z.array(z.uuid()).max(1e3),
	selectedPageIds: z.array(z.uuid()).max(1e3),
	reason: z.string().min(10).max(2e3)
});
const RemovalPlan = z.strictObject({
	id: z.uuid(),
	impactHash: z.string().min(64).max(64),
	expiresAt: z.iso.datetime({ offset: true }),
	ownedAuditCount: z.number().int().min(0),
	transferCount: z.number().int().min(0),
	deleteCount: z.number().int().min(0),
	heldCount: z.number().int().min(0),
	targetUserId: z.uuid().nullable(),
	blockedReasons: z.array(z.string().min(1).max(200)).max(20)
});
const RemovalConfirm = z.strictObject({
	planId: z.uuid(),
	impactHash: z.string().min(64).max(64),
	confirmedMemberId: z.uuid()
});
const WorkspaceList = z.strictObject({
	items: z.array(Workspace).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const MemberList = z.strictObject({
	items: z.array(Member).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const InvitationList = z.strictObject({
	items: z.array(Invitation).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const SecurityEventList = z.strictObject({
	items: z.array(SecurityEvent).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const WorkspacePersonList = z.strictObject({
	items: z.array(WorkspacePerson).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ListWorkspacesQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum(["active", "retired"]).optional()
});
const ListMembersQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"invited",
		"active",
		"removed"
	]).optional()
});
const ListInvitationsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"pending",
		"accepted",
		"expired",
		"revoked"
	]).optional()
});
const ListActivityQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional()
});
const ListWorkspacePeopleQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional()
});
// src/generated/operator.ts
var operator_exports = /* @__PURE__ */ __exportAll({
	ConfigUpdate: () => ConfigUpdate,
	Impersonation: () => Impersonation,
	ImpersonationEnd: () => ImpersonationEnd,
	ImpersonationList: () => ImpersonationList,
	ImpersonationStart: () => ImpersonationStart,
	JobList: () => JobList,
	OperatorImpersonationsQuery: () => OperatorImpersonationsQuery,
	OperatorJobsQuery: () => OperatorJobsQuery,
	OperatorMembersQuery: () => OperatorMembersQuery,
	OperatorOrganizationsQuery: () => OperatorOrganizationsQuery,
	OperatorSecurityEvent: () => OperatorSecurityEvent,
	OperatorSecurityEventList: () => OperatorSecurityEventList,
	OperatorSecurityEventsQuery: () => OperatorSecurityEventsQuery,
	OperatorSummary: () => OperatorSummary,
	OperatorWorkspacesQuery: () => OperatorWorkspacesQuery,
	OrganizationList: () => OrganizationList,
	PlatformConfig: () => PlatformConfig,
	PrivacyCommandExecution: () => PrivacyCommandExecution,
	PrivacyMaintenanceCommand: () => PrivacyMaintenanceCommand,
	Provision: () => Provision,
	SecurityIncident: () => SecurityIncident,
	SecurityIncidentList: () => SecurityIncidentList,
	WorkspaceCreate: () => WorkspaceCreate
});
const Provision = z.strictObject({
	organizationName: z.string().min(1).max(200),
	workspaceName: z.string().min(1).max(200),
	timezone: z.string().min(1).max(80),
	locale: z.enum([
		"en",
		"de",
		"es",
		"fr",
		"tr"
	]),
	administratorEmail: z.email(),
	planId: z.uuid().nullable(),
	terms: AgreementTerms.nullable(),
	billing: BillingDetails.nullable(),
	freeFirstMonth: z.boolean()
});
const WorkspaceCreate = z.strictObject({
	name: z.string().min(1).max(200),
	timezone: z.string().min(1).max(80)
});
const PlatformConfig = z.strictObject({
	revision: z.number().int().min(1),
	aiEnabled: z.boolean(),
	uploadReservationsPerOrganizationDay: z.number().int().min(0)
});
const ConfigUpdate = z.strictObject({
	expectedRevision: z.number().int().min(1),
	aiEnabled: z.boolean(),
	reason: z.string().min(10).max(2e3),
	uploadReservationsPerOrganizationDay: z.number().int().min(0)
});
const OperatorSummary = z.strictObject({
	organizations: z.number().int().min(0),
	failedJobs: z.number().int().min(0),
	oldestQueuedSeconds: z.number().int().min(0),
	estimatedSpendUsdCents: z.number().int().min(0),
	asOf: z.iso.datetime({ offset: true }),
	activeImpersonations: z.number().int().min(0),
	openSecurityIncidents: z.number().int().min(0),
	highSecurityIncidents: z.number().int().min(0),
	topOffenders: z.array(z.strictObject({
		actorEmail: z.string().min(1).max(254).nullable(),
		ipPrefix: z.string().min(1).max(50).nullable(),
		count: z.number().int().min(0)
	})).max(3)
});
const PrivacyMaintenanceCommand = z.strictObject({
	requestReference: z.string().min(1).max(120),
	organizationId: z.uuid(),
	action: z.enum([
		"discover",
		"prepareResponse",
		"restrict",
		"releaseRestriction",
		"erase",
		"placeHold",
		"releaseHold"
	]),
	resources: z.array(z.strictObject({
		kind: z.enum([
			"workspace",
			"audit",
			"remark",
			"media"
		]),
		id: z.uuid()
	})).min(1).max(1e3),
	instructionReference: z.string().min(1).max(500),
	approvedBy: z.uuid(),
	reviewedBy: z.uuid().nullable().optional(),
	controllerVerification: z.string().min(1).max(500).nullable().optional(),
	expiresAt: z.iso.datetime({ offset: true }),
	searchTerms: z.array(z.string().min(3).max(200)).max(20).optional(),
	redactTerms: z.array(z.string().min(1).max(200)).max(50).optional(),
	withdrawScore: z.boolean().optional(),
	hold: z.strictObject({
		purpose: z.string().min(1).max(500),
		reviewAt: z.iso.datetime({ offset: true })
	}).nullable().optional()
});
const PrivacyCommandExecution = z.strictObject({
	commandId: z.uuid(),
	expectedImpactHash: z.string().min(64).max(64)
});
const ImpersonationStart = z.strictObject({
	targetUserId: z.uuid(),
	reason: z.string().min(10).max(2e3)
});
const Impersonation = z.strictObject({
	id: z.uuid(),
	revision: z.number().int().min(1),
	organizationId: z.uuid(),
	organizationName: z.string().min(1).max(200),
	operatorId: z.uuid(),
	operatorName: z.string().min(1).max(200),
	targetUserId: z.uuid(),
	targetName: z.string().min(1).max(200),
	targetEmail: z.string().min(1).max(254),
	access: z.enum(["read", "write"]),
	reason: z.string().min(1).max(2e3),
	startedAt: z.iso.datetime({ offset: true }),
	expiresAt: z.iso.datetime({ offset: true }),
	endedAt: z.iso.datetime({ offset: true }).nullable(),
	endReason: z.enum([
		"returned",
		"expired",
		"revoked",
		"membership_changed",
		"operator_removed",
		"signed_out",
		"session_ended",
		"replaced",
		"organization_deleted",
		"failed",
		"migrated"
	]).nullable(),
	state: z.enum(["active", "ended"]),
	writeCount: z.number().int().min(0)
});
const ImpersonationEnd = z.strictObject({
	restored: z.boolean(),
	organizationId: z.uuid().nullable()
});
const OperatorImpersonationsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	status: z.enum(["active", "ended"]).optional(),
	organizationId: z.uuid().optional()
});
const SecurityIncident = z.strictObject({
	id: z.uuid(),
	rule: z.enum([
		"credential_stuffing",
		"account_attack",
		"excessive_use",
		"request_flood",
		"cross_tenant_probe",
		"organization_scan",
		"enumeration",
		"privilege_probing",
		"error_exploitation",
		"share_token_guessing",
		"impersonation_pattern",
		"bulk_export",
		"admin_burst"
	]),
	severity: z.enum([
		"low",
		"medium",
		"high"
	]),
	state: z.enum(["open", "resolved"]),
	subjectKind: z.enum([
		"account",
		"ipPrefix",
		"operator"
	]),
	actorId: z.uuid().nullable(),
	actorEmail: z.string().min(1).max(254).nullable(),
	ipPrefix: z.string().min(1).max(50).nullable(),
	organizationIds: z.array(z.uuid()).max(20),
	metric: z.number().int().min(0),
	unit: z.enum([
		"requestsPerMinute",
		"organizations",
		"accounts",
		"attempts",
		"objects",
		"errors",
		"requestShapes",
		"impersonations",
		"changes",
		"exports"
	]),
	count: z.number().int().min(0),
	firstSeen: z.iso.datetime({ offset: true }),
	lastSeen: z.iso.datetime({ offset: true }),
	openedAt: z.iso.datetime({ offset: true }),
	resolvedAt: z.iso.datetime({ offset: true }).nullable()
});
const SecurityIncidentList = z.strictObject({
	items: z.array(SecurityIncident).max(200),
	asOf: z.iso.datetime({ offset: true })
});
const OperatorSecurityEvent = z.strictObject({
	id: z.uuid(),
	organizationId: z.uuid().nullable(),
	organizationName: z.string().min(1).max(200).nullable(),
	workspaceId: z.uuid().nullable(),
	actorId: z.uuid().nullable(),
	actorEmail: z.string().min(1).max(254).nullable(),
	realActorId: z.uuid().nullable(),
	realActorEmail: z.string().min(1).max(254).nullable(),
	action: z.string().min(1).max(100),
	result: z.enum([
		"ok",
		"denied",
		"failed"
	]),
	targetType: z.string().min(1).max(80).nullable(),
	targetId: z.uuid().nullable(),
	reason: z.string().min(1).max(2e3).nullable(),
	metadata: z.record(z.string(), z.union([
		z.string().max(200),
		z.number(),
		z.boolean(),
		z.null()
	])).refine((v) => Object.keys(v).length <= 30, "Too many entries"),
	requestId: z.uuid().nullable(),
	impersonationId: z.uuid().nullable(),
	ipPrefix: z.string().min(1).max(50).nullable(),
	createdAt: z.iso.datetime({ offset: true }),
	source: z.enum(["change", "request"]),
	route: z.string().min(1).max(80).nullable(),
	status: z.number().int().min(0).nullable(),
	count: z.number().int().min(1),
	classification: z.enum([
		"own",
		"former_member",
		"cross_tenant",
		"unknown"
	]).nullable(),
	addressTag: z.string().min(8).max(8).nullable()
});
const OperatorSecurityEventsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional(),
	source: z.enum(["change", "request"]).optional(),
	action: z.string().min(1).max(100).optional(),
	account: z.string().min(1).max(254).optional(),
	organizationId: z.uuid().optional(),
	route: z.string().min(1).max(80).optional(),
	ipPrefix: z.string().min(1).max(50).optional(),
	classification: z.enum([
		"own",
		"former_member",
		"cross_tenant",
		"unknown"
	]).optional(),
	impersonationId: z.uuid().optional()
});
const OrganizationList = z.strictObject({
	items: z.array(Organization).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const JobList = z.strictObject({
	items: z.array(Job).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const OperatorSecurityEventList = z.strictObject({
	items: z.array(OperatorSecurityEvent).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const ImpersonationList = z.strictObject({
	items: z.array(Impersonation).max(100),
	nextCursor: z.string().min(1).max(1024).nullable()
});
const OperatorOrganizationsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"pending",
		"active",
		"grace",
		"suspended",
		"deleting"
	]).optional()
});
const OperatorWorkspacesQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum(["active", "retired"]).optional()
});
const OperatorMembersQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	search: z.string().max(200).optional(),
	status: z.enum([
		"invited",
		"active",
		"removed"
	]).optional()
});
const OperatorJobsQuery = z.strictObject({
	cursor: z.string().min(1).max(1024).optional(),
	limit: z.coerce.number().int().min(1).max(100).optional(),
	status: z.enum([
		"queued",
		"running",
		"succeeded",
		"failed",
		"cancelled"
	]).optional(),
	from: z.iso.datetime({ offset: true }).optional(),
	to: z.iso.datetime({ offset: true }).optional()
});
// src/generated/realtime.ts
var realtime_exports = /* @__PURE__ */ __exportAll({
	SocketHandshake: () => SocketHandshake,
	SocketRequest: () => SocketRequest,
	SocketTicket: () => SocketTicket,
	SocketUpgrade: () => SocketUpgrade
});
const SocketRequest = z.strictObject({
	resourceType: z.enum([
		"workspace",
		"audit",
		"analyticsPage"
	]),
	resourceId: z.uuid()
});
const SocketTicket = z.strictObject({
	token: z.string().min(16).max(512),
	expiresAt: z.iso.datetime({ offset: true }),
	path: z.string().min(1).max(1e3)
});
const SocketHandshake = z.strictObject({ ticket: z.string().min(16).max(512) });
const SocketUpgrade = z.strictObject({ status: z.literal(101) });
// src/generated/endpoints.ts
const endpoints = [
	{
		operationId: "signIn",
		method: "POST",
		path: "/api/v1/account/sign-in",
		permission: "public",
		requestSchema: "SignIn",
		requestLocation: "body",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "signOut",
		method: "POST",
		path: "/api/v1/account/sign-out",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "getSession",
		method: "GET",
		path: "/api/v1/account/session",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "requestPasswordReset",
		method: "POST",
		path: "/api/v1/account/password-reset",
		permission: "public",
		requestSchema: "Email",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "resetPassword",
		method: "POST",
		path: "/api/v1/account/password-reset/confirm",
		permission: "public",
		requestSchema: "ResetPassword",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "verifyEmail",
		method: "POST",
		path: "/api/v1/account/email-verification",
		permission: "public",
		requestSchema: "Token",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "resendVerification",
		method: "POST",
		path: "/api/v1/account/email-verification/resend",
		permission: "public",
		requestSchema: "Email",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "previewInvitation",
		method: "POST",
		path: "/api/v1/account/invitations/preview",
		permission: "public",
		requestSchema: "Token",
		requestLocation: "body",
		responseSchema: "InvitationPreview",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "acceptInvitation",
		method: "POST",
		path: "/api/v1/account/invitations/accept",
		permission: "public",
		requestSchema: "AcceptInvitation",
		requestLocation: "body",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "completeMfa",
		method: "POST",
		path: "/api/v1/account/mfa/challenge",
		permission: "public",
		requestSchema: "MfaChallenge",
		requestLocation: "body",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getSignInOptions",
		method: "GET",
		path: "/api/v1/account/sign-in-options",
		permission: "public",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "SignInOptions",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "beginSocialSignIn",
		method: "POST",
		path: "/api/v1/account/sign-in/social",
		permission: "public",
		requestSchema: "SocialSignIn",
		requestLocation: "body",
		responseSchema: "ProviderRedirect",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "completeSocialSignIn",
		method: "POST",
		path: "/api/v1/account/sign-in/social/complete",
		permission: "public",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "beginPasskeySignIn",
		method: "POST",
		path: "/api/v1/account/sign-in/passkey/options",
		permission: "public",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "WebAuthnOptions",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "finishPasskeySignIn",
		method: "POST",
		path: "/api/v1/account/sign-in/passkey",
		permission: "public",
		requestSchema: "PasskeySignIn",
		requestLocation: "body",
		responseSchema: "Session",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "beginMfa",
		method: "POST",
		path: "/api/v1/account/mfa/setup",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "MfaSetup",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "confirmMfa",
		method: "POST",
		path: "/api/v1/account/mfa/confirm",
		permission: "session",
		requestSchema: "MfaChallenge",
		requestLocation: "body",
		responseSchema: "MfaRecoveryCodes",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "getAvatar",
		method: "GET",
		path: "/api/v1/account/avatar",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Avatar",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "uploadAvatar",
		method: "PUT",
		path: "/api/v1/account/avatar",
		permission: "session",
		requestSchema: "Binary",
		requestLocation: "body",
		responseSchema: "Avatar",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "useProviderAvatar",
		method: "PUT",
		path: "/api/v1/account/avatar/provider",
		permission: "session",
		requestSchema: "AvatarProvider",
		requestLocation: "body",
		responseSchema: "Avatar",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "deleteAvatar",
		method: "DELETE",
		path: "/api/v1/account/avatar",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Avatar",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "avatarContent",
		method: "GET",
		path: "/api/v1/avatars/:avatarId",
		permission: "public",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Binary",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "acknowledgeMfa",
		method: "POST",
		path: "/api/v1/account/mfa/acknowledge",
		permission: "session",
		requestSchema: "MfaAcknowledge",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "cancelMfa",
		method: "POST",
		path: "/api/v1/account/mfa/cancel",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "disableMfa",
		method: "POST",
		path: "/api/v1/account/mfa/disable",
		permission: "session",
		requestSchema: "MfaChallenge",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "getProfile",
		method: "GET",
		path: "/api/v1/account/profile",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Profile",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateProfile",
		method: "PATCH",
		path: "/api/v1/account/profile",
		permission: "session",
		requestSchema: "Profile",
		requestLocation: "body",
		responseSchema: "Profile",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "changePassword",
		method: "POST",
		path: "/api/v1/account/password",
		permission: "session",
		requestSchema: "PasswordChange",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "reauthenticate",
		method: "POST",
		path: "/api/v1/account/reauthenticate",
		permission: "session",
		requestSchema: "Reauthenticate",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "listSessions",
		method: "GET",
		path: "/api/v1/account/sessions",
		permission: "session",
		requestSchema: "ListSessionsQuery",
		requestLocation: "query",
		responseSchema: "UserSessionList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "revokeSession",
		method: "DELETE",
		path: "/api/v1/account/sessions/:sessionId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listLinkedAccounts",
		method: "GET",
		path: "/api/v1/account/linked-accounts",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "LinkedAccountList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "linkSocialAccount",
		method: "POST",
		path: "/api/v1/account/linked-accounts",
		permission: "session",
		requestSchema: "SocialProvider",
		requestLocation: "body",
		responseSchema: "ProviderRedirect",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "unlinkSocialAccount",
		method: "DELETE",
		path: "/api/v1/account/linked-accounts/:provider",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listPasskeys",
		method: "GET",
		path: "/api/v1/account/passkeys",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "PasskeyList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "beginPasskeyRegistration",
		method: "POST",
		path: "/api/v1/account/passkeys/options",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "WebAuthnOptions",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "finishPasskeyRegistration",
		method: "POST",
		path: "/api/v1/account/passkeys",
		permission: "session",
		requestSchema: "PasskeyRegistration",
		requestLocation: "body",
		responseSchema: "Passkey",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "deletePasskey",
		method: "DELETE",
		path: "/api/v1/account/passkeys/:passkeyId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listScopes",
		method: "GET",
		path: "/api/v1/account/scopes",
		permission: "session",
		requestSchema: "ListScopesQuery",
		requestLocation: "query",
		responseSchema: "ScopeList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listMyOrganizations",
		method: "GET",
		path: "/api/v1/account/organizations",
		permission: "session",
		requestSchema: "ListMyOrganizationsQuery",
		requestLocation: "query",
		responseSchema: "OrganizationChoiceList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listNotifications",
		method: "GET",
		path: "/api/v1/account/notifications",
		permission: "session",
		requestSchema: "ListNotificationsQuery",
		requestLocation: "query",
		responseSchema: "NotificationList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "readNotification",
		method: "POST",
		path: "/api/v1/account/notifications/:notificationId/read",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "getOrganization",
		method: "GET",
		path: "/api/v1/organizations/:organizationId",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Organization",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateOrganization",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId",
		permission: "org.admin",
		requestSchema: "OrganizationUpdate",
		requestLocation: "body",
		responseSchema: "Organization",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getOrganizationPrivacy",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/privacy",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "OrganizationPrivacyNotice",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateOrganizationPrivacy",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/privacy",
		permission: "org.admin",
		requestSchema: "OrganizationPrivacyUpdate",
		requestLocation: "body",
		responseSchema: "OrganizationPrivacyNotice",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listWorkspaces",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces",
		permission: "org.admin",
		requestSchema: "ListWorkspacesQuery",
		requestLocation: "query",
		responseSchema: "WorkspaceList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateWorkspace",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId",
		permission: "workspace.manage",
		requestSchema: "WorkspaceUpdate",
		requestLocation: "body",
		responseSchema: "Workspace",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listMembers",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/members",
		permission: "org.admin",
		requestSchema: "ListMembersQuery",
		requestLocation: "query",
		responseSchema: "MemberList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "inviteMember",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/invitations",
		permission: "org.admin",
		requestSchema: "Invite",
		requestLocation: "body",
		responseSchema: "Invitation",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "listInvitations",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/invitations",
		permission: "org.admin",
		requestSchema: "ListInvitationsQuery",
		requestLocation: "query",
		responseSchema: "InvitationList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "resendInvitation",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/invitations/:invitationId/resend",
		permission: "org.admin",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Invitation",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "revokeInvitation",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/invitations/:invitationId",
		permission: "org.admin",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateMember",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/members/:memberId",
		permission: "org.admin",
		requestSchema: "MemberUpdate",
		requestLocation: "body",
		responseSchema: "Member",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "removeMember",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/members/:memberId",
		permission: "org.admin",
		requestSchema: "RemovalConfirm",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getBranding",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/branding",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Branding",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateBranding",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/branding",
		permission: "org.admin",
		requestSchema: "BrandingUpdate",
		requestLocation: "body",
		responseSchema: "Branding",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getSecurityPolicy",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/security",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "SecurityPolicy",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateSecurityPolicy",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/security",
		permission: "org.admin",
		requestSchema: "SecurityPolicyUpdate",
		requestLocation: "body",
		responseSchema: "SecurityPolicy",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getRetention",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/retention",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Retention",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateRetention",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/retention",
		permission: "org.admin",
		requestSchema: "RetentionUpdate",
		requestLocation: "body",
		responseSchema: "Retention",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getEntitlement",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/entitlement",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Entitlement",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getToolAccess",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/tool-access",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "ToolAccess",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getUsage",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/usage",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Usage",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listActivity",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/activity",
		permission: "org.admin",
		requestSchema: "ListActivityQuery",
		requestLocation: "query",
		responseSchema: "SecurityEventList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "exportOrganization",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/data-export",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "downloadOrganizationExport",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/data-export/:jobId/content",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Binary",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "deleteOrganization",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/deletion-request",
		permission: "org.admin",
		requestSchema: "DeleteOrganization",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "getWorkspace",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Workspace",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listWorkspacePeople",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/people",
		permission: "workspace.read",
		requestSchema: "ListWorkspacePeopleQuery",
		requestLocation: "query",
		responseSchema: "WorkspacePersonList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listAreas",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/areas",
		permission: "workspace.read",
		requestSchema: "ListAreasQuery",
		requestLocation: "query",
		responseSchema: "AreaList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createArea",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/areas",
		permission: "workspace.manage",
		requestSchema: "AreaCreate",
		requestLocation: "body",
		responseSchema: "Area",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "updateArea",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/areas/:areaId",
		permission: "workspace.manage",
		requestSchema: "AreaUpdate",
		requestLocation: "body",
		responseSchema: "Area",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listTemplates",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates",
		permission: "workspace.read",
		requestSchema: "ListTemplatesQuery",
		requestLocation: "query",
		responseSchema: "TemplateList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createTemplate",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates",
		permission: "workspace.manage",
		requestSchema: "TemplateCreate",
		requestLocation: "body",
		responseSchema: "Template",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "getTemplate",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId",
		permission: "workspace.manage",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Template",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateTemplate",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId",
		permission: "workspace.manage",
		requestSchema: "TemplateUpdate",
		requestLocation: "body",
		responseSchema: "Template",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "setTemplateFlags",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId/settings",
		permission: "workspace.manage",
		requestSchema: "TemplateFlags",
		requestLocation: "body",
		responseSchema: "Template",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "publishTemplate",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId/publish",
		permission: "workspace.manage",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "TemplateVersion",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "listTemplateVersions",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId/versions",
		permission: "workspace.read",
		requestSchema: "ListTemplateVersionsQuery",
		requestLocation: "query",
		responseSchema: "TemplateVersionList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listWorkspaceTemplateVersions",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/template-versions",
		permission: "workspace.read",
		requestSchema: "ListWorkspaceTemplateVersionsQuery",
		requestLocation: "query",
		responseSchema: "TemplateVersionList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "previewTemplateImport",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/import-preview",
		permission: "workspace.manage",
		requestSchema: "ImportCsv",
		requestLocation: "body",
		responseSchema: "ImportPreview",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "listAudits",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits",
		permission: "workspace.read",
		requestSchema: "ListAuditsQuery",
		requestLocation: "query",
		responseSchema: "AuditSummaryList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createAudit",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits",
		permission: "audit.create",
		requestSchema: "AuditCreate",
		requestLocation: "body",
		responseSchema: "Audit",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "getAudit",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Audit",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getPreviousComparableAudit",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/previous-comparable",
		permission: "workspace.read",
		requestSchema: "PreviousAuditQuery",
		requestLocation: "query",
		responseSchema: "PreviousComparableAudit",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateAudit",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId",
		permission: "audit.edit",
		requestSchema: "AuditMetadata",
		requestLocation: "body",
		responseSchema: "Audit",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listAnswers",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/answers",
		permission: "workspace.read",
		requestSchema: "ListAnswersQuery",
		requestLocation: "query",
		responseSchema: "AnswerList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "saveAnswer",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/answers/:questionKey",
		permission: "audit.edit",
		requestSchema: "AnswerUpdate",
		requestLocation: "body",
		responseSchema: "Answer",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listRemarks",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/answers/:questionKey/remarks",
		permission: "workspace.read",
		requestSchema: "ListRemarksQuery",
		requestLocation: "query",
		responseSchema: "RemarkList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createRemark",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/answers/:questionKey/remarks",
		permission: "audit.edit",
		requestSchema: "RemarkCreate",
		requestLocation: "body",
		responseSchema: "Remark",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "updateRemark",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/remarks/:remarkId",
		permission: "audit.edit",
		requestSchema: "RemarkUpdate",
		requestLocation: "body",
		responseSchema: "Remark",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "deleteRemark",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/remarks/:remarkId",
		permission: "audit.edit",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "submitAudit",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/submit",
		permission: "audit.submit",
		requestSchema: "Submit",
		requestLocation: "body",
		responseSchema: "AuditRevision",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "deleteDraft",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId",
		permission: "audit.submit",
		requestSchema: "ReasonedRevision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getAuditRevision",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/revisions/:auditRevisionId",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "AuditRevision",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listRevisionRemarks",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/revisions/:auditRevisionId/remarks",
		permission: "workspace.read",
		requestSchema: "ListRevisionRemarksQuery",
		requestLocation: "query",
		responseSchema: "RemarkList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "voidAudit",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/void",
		permission: "audit.owner",
		requestSchema: "ReasonedRevision",
		requestLocation: "body",
		responseSchema: "Audit",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "reserveUpload",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/uploads",
		permission: "session",
		requestSchema: "UploadReservation",
		requestLocation: "body",
		responseSchema: "UploadTicket",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "uploadBytes",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/uploads/:uploadId",
		permission: "session",
		requestSchema: "Binary",
		requestLocation: "body",
		responseSchema: "Media",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getMedia",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/media/:mediaId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Media",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "downloadMedia",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/media/:mediaId/content",
		permission: "session",
		requestSchema: "MediaContentQuery",
		requestLocation: "query",
		responseSchema: "Binary",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "deleteMedia",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/media/:mediaId",
		permission: "session",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listFindings",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings",
		permission: "workspace.read",
		requestSchema: "ListFindingsQuery",
		requestLocation: "query",
		responseSchema: "FindingSummaryList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createFinding",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings",
		permission: "audit.create",
		requestSchema: "FindingCreate",
		requestLocation: "body",
		responseSchema: "Finding",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "getFinding",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings/:findingId",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Finding",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updateFinding",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings/:findingId",
		permission: "finding.owner",
		requestSchema: "FindingUpdate",
		requestLocation: "body",
		responseSchema: "Finding",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "transitionFinding",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings/:findingId/transitions",
		permission: "finding.update",
		requestSchema: "FindingTransition",
		requestLocation: "body",
		responseSchema: "Finding",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "listFindingEvents",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings/:findingId/events",
		permission: "workspace.read",
		requestSchema: "ListFindingEventsQuery",
		requestLocation: "query",
		responseSchema: "FindingEventList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listPages",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages",
		permission: "workspace.read",
		requestSchema: "ListPagesQuery",
		requestLocation: "query",
		responseSchema: "AnalyticsPageList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createPage",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages",
		permission: "audit.create",
		requestSchema: "PageCreate",
		requestLocation: "body",
		responseSchema: "AnalyticsPage",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "getPage",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "PageVersion",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getPageDraft",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId/draft",
		permission: "page.edit",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "AnalyticsPage",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updatePage",
		method: "PATCH",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId",
		permission: "page.edit",
		requestSchema: "PageUpdate",
		requestLocation: "body",
		responseSchema: "AnalyticsPage",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "publishPage",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId/publish",
		permission: "page.publish",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "PageVersion",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "deletePage",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId",
		permission: "page.edit",
		requestSchema: "ReasonedRevision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "queryWidget",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-query",
		permission: "workspace.read",
		requestSchema: "WidgetQuery",
		requestLocation: "body",
		responseSchema: "WidgetData",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "previewWidget",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-query/preview",
		permission: "audit.create",
		requestSchema: "WidgetPreview",
		requestLocation: "body",
		responseSchema: "WidgetData",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createAiTask",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai-tasks",
		permission: "audit.create",
		requestSchema: "AiCreate",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "getAiTask",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai-tasks/:taskId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "AiResult",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "cancelAiTask",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai-tasks/:taskId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getJob",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/jobs/:jobId",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Job",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "cancelJob",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/jobs/:jobId/cancel",
		permission: "session",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "createSocketTicket",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/realtime-ticket",
		permission: "workspace.read",
		requestSchema: "SocketRequest",
		requestLocation: "body",
		responseSchema: "SocketTicket",
		successStatus: 201,
		idempotencyRequired: false
	},
	{
		operationId: "connectSocket",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/realtime",
		permission: "workspace.read",
		requestSchema: "SocketHandshake",
		requestLocation: "query",
		responseSchema: "SocketUpgrade",
		successStatus: 101,
		idempotencyRequired: false
	},
	{
		operationId: "operatorSummary",
		method: "GET",
		path: "/api/v1/operator/summary",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "OperatorSummary",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorOrganizations",
		method: "GET",
		path: "/api/v1/operator/organizations",
		permission: "operator",
		requestSchema: "OperatorOrganizationsQuery",
		requestLocation: "query",
		responseSchema: "OrganizationList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "provisionOrganization",
		method: "POST",
		path: "/api/v1/operator/organizations",
		permission: "operator",
		requestSchema: "Provision",
		requestLocation: "body",
		responseSchema: "Organization",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "operatorOrganization",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Organization",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorWorkspaces",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/workspaces",
		permission: "operator",
		requestSchema: "OperatorWorkspacesQuery",
		requestLocation: "query",
		responseSchema: "WorkspaceList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorMembers",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/members",
		permission: "operator",
		requestSchema: "OperatorMembersQuery",
		requestLocation: "query",
		responseSchema: "MemberList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorUsage",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/usage",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Usage",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorReadEntitlement",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/entitlement",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Entitlement",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorCreateWorkspace",
		method: "POST",
		path: "/api/v1/operator/organizations/:organizationId/workspaces",
		permission: "operator",
		requestSchema: "WorkspaceCreate",
		requestLocation: "body",
		responseSchema: "Workspace",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "operatorEntitlement",
		method: "PATCH",
		path: "/api/v1/operator/organizations/:organizationId/entitlement",
		permission: "operator",
		requestSchema: "EntitlementUpdate",
		requestLocation: "body",
		responseSchema: "Entitlement",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorJobs",
		method: "GET",
		path: "/api/v1/operator/jobs",
		permission: "operator",
		requestSchema: "OperatorJobsQuery",
		requestLocation: "query",
		responseSchema: "JobList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "retryJob",
		method: "POST",
		path: "/api/v1/operator/jobs/:jobId/retry",
		permission: "operator",
		requestSchema: "ReasonedRevision",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "operatorSecurity",
		method: "GET",
		path: "/api/v1/operator/security-events",
		permission: "operator",
		requestSchema: "OperatorSecurityEventsQuery",
		requestLocation: "query",
		responseSchema: "OperatorSecurityEventList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getPlatformConfig",
		method: "GET",
		path: "/api/v1/operator/configuration",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "PlatformConfig",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "previewMemberRemoval",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/members/:memberId/removal-preview",
		permission: "org.admin",
		requestSchema: "RemovalSelection",
		requestLocation: "body",
		responseSchema: "RemovalPlan",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "updateAuditAccess",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/audits/:auditId/access",
		permission: "audit.owner",
		requestSchema: "AuditAccessUpdate",
		requestLocation: "body",
		responseSchema: "AuditAccess",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updatePageAccess",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-pages/:pageId/access",
		permission: "page.owner",
		requestSchema: "PageAccessUpdate",
		requestLocation: "body",
		responseSchema: "AnalyticsPage",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "linkFindingObservation",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/findings/:findingId/observations",
		permission: "finding.update",
		requestSchema: "FindingObservation",
		requestLocation: "body",
		responseSchema: "Finding",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "sendContactMessage",
		method: "POST",
		path: "/api/v1/contact-messages",
		permission: "public",
		requestSchema: "ContactMessage",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "updatePlatformConfig",
		method: "PATCH",
		path: "/api/v1/operator/configuration",
		permission: "operator",
		requestSchema: "ConfigUpdate",
		requestLocation: "body",
		responseSchema: "PlatformConfig",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "startImpersonation",
		method: "POST",
		path: "/api/v1/operator/organizations/:organizationId/impersonations",
		permission: "operator",
		requestSchema: "ImpersonationStart",
		requestLocation: "body",
		responseSchema: "Impersonation",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "endImpersonation",
		method: "POST",
		path: "/api/v1/account/impersonation/end",
		permission: "public",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "ImpersonationEnd",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorImpersonations",
		method: "GET",
		path: "/api/v1/operator/impersonations",
		permission: "operator",
		requestSchema: "OperatorImpersonationsQuery",
		requestLocation: "query",
		responseSchema: "ImpersonationList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorEndImpersonation",
		method: "POST",
		path: "/api/v1/operator/impersonations/:impersonationId/end",
		permission: "operator",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Impersonation",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "operatorSecurityIncidents",
		method: "GET",
		path: "/api/v1/operator/security/incidents",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "SecurityIncidentList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createTemplateImport",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai/template-imports",
		permission: "workspace.manage",
		requestSchema: "AiTemplateImport",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "suggestCategoryQuestions",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai/question-suggestions",
		permission: "workspace.manage",
		requestSchema: "AiQuestionSuggestion",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "getQuestionSuggestionContext",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai/question-suggestions/context",
		permission: "workspace.manage",
		requestSchema: "AiQuestionContextQuery",
		requestLocation: "query",
		responseSchema: "AiQuestionContext",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "suggestDashboard",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/ai/dashboard-suggestions",
		permission: "audit.create",
		requestSchema: "AiDashboardSuggestion",
		requestLocation: "body",
		responseSchema: "Job",
		successStatus: 202,
		idempotencyRequired: true
	},
	{
		operationId: "listTemplateAreas",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId/areas",
		permission: "workspace.read",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "TemplateAreas",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "setTemplateAreas",
		method: "PUT",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/templates/:templateId/areas",
		permission: "workspace.manage",
		requestSchema: "TemplateAreasUpdate",
		requestLocation: "body",
		responseSchema: "TemplateAreas",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listPlans",
		method: "GET",
		path: "/api/v1/operator/plans",
		permission: "operator",
		requestSchema: "ListPlansQuery",
		requestLocation: "query",
		responseSchema: "PlanList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "createPlan",
		method: "POST",
		path: "/api/v1/operator/plans",
		permission: "operator",
		requestSchema: "PlanInput",
		requestLocation: "body",
		responseSchema: "Plan",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "updatePlan",
		method: "PATCH",
		path: "/api/v1/operator/plans/:planId",
		permission: "operator",
		requestSchema: "PlanUpdate",
		requestLocation: "body",
		responseSchema: "Plan",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "archivePlan",
		method: "DELETE",
		path: "/api/v1/operator/plans/:planId",
		permission: "operator",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorAgreement",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/agreement",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "Agreement",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "listAgreementVersions",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/agreement/versions",
		permission: "operator",
		requestSchema: "ListAgreementVersionsQuery",
		requestLocation: "query",
		responseSchema: "AgreementVersionList",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "previewAgreementChange",
		method: "POST",
		path: "/api/v1/operator/organizations/:organizationId/agreement/preview",
		permission: "operator",
		requestSchema: "AgreementChange",
		requestLocation: "body",
		responseSchema: "AgreementPreview",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "confirmAgreementChange",
		method: "POST",
		path: "/api/v1/operator/organizations/:organizationId/agreement/confirm",
		permission: "operator",
		requestSchema: "AgreementConfirm",
		requestLocation: "body",
		responseSchema: "Agreement",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "updateBillingDetails",
		method: "PUT",
		path: "/api/v1/operator/organizations/:organizationId/agreement/billing",
		permission: "operator",
		requestSchema: "BillingDetailsUpdate",
		requestLocation: "body",
		responseSchema: "Agreement",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "operatorBilling",
		method: "GET",
		path: "/api/v1/operator/organizations/:organizationId/billing",
		permission: "operator",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "BillingOverview",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "getBilling",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/billing",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "BillingOverview",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "startAllowanceReset",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/allowance-resets",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "AllowanceResetPurchase",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "syncAllowanceReset",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/allowance-resets/:purchaseId/sync",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "AllowanceResetPurchase",
		successStatus: 200,
		idempotencyRequired: true
	},
	{
		operationId: "createBillingPortal",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/billing/portal",
		permission: "org.admin",
		requestSchema: "Empty",
		requestLocation: "body",
		responseSchema: "BillingPortal",
		successStatus: 201,
		idempotencyRequired: true
	},
	{
		operationId: "getSidebarBranding",
		method: "GET",
		path: "/api/v1/organizations/:organizationId/sidebar-branding",
		permission: "session",
		requestSchema: "Empty",
		requestLocation: "query",
		responseSchema: "SidebarBranding",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "receiveStripeEvent",
		method: "POST",
		path: "/api/v1/billing/stripe/webhook",
		permission: "public",
		requestSchema: "Binary",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "deleteArea",
		method: "DELETE",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/areas/:areaId",
		permission: "workspace.manage",
		requestSchema: "Revision",
		requestLocation: "body",
		responseSchema: "Ok",
		successStatus: 200,
		idempotencyRequired: false
	},
	{
		operationId: "queryReportWidget",
		method: "POST",
		path: "/api/v1/organizations/:organizationId/workspaces/:workspaceId/analytics-reports/:reportKey/query",
		permission: "workspace.read",
		requestSchema: "WidgetReportQuery",
		requestLocation: "body",
		responseSchema: "WidgetData",
		successStatus: 200,
		idempotencyRequired: false
	}
];
const endpointById = Object.fromEntries(endpoints.map((e) => [e.operationId, e]));
// src/generated/registry.ts
const schemas = {
	...account_exports,
	...ai_exports,
	...analytics_exports,
	...areas_exports,
	...audits_exports,
	...billing_exports,
	...common_exports,
	...exports_exports,
	...findings_exports,
	...media_exports,
	...operator_exports,
	...organization_exports,
	...realtime_exports,
	...templates_exports
};
// src/errors.ts
/** Stable machine-readable error codes. Display text is mapped in @hlt/i18n. */
const errorCodes = [
	"malformed",
	"unauthenticated",
	"mfa_required",
	"mfa_enrollment_required",
	"sign_in_required",
	"read_only",
	"recent_auth_required",
	"forbidden",
	"feature_disabled",
	"not_found",
	"stale_revision",
	"conflict",
	"idempotency_conflict",
	"payload_too_large",
	"validation_failed",
	"rate_limited",
	"quota_exceeded",
	"translation_pending",
	"translation_unavailable",
	"seat_limit_reached",
	"unavailable",
	"internal"
];
const statusForCode = {
	malformed: 400,
	unauthenticated: 401,
	mfa_required: 401,
	mfa_enrollment_required: 403,
	sign_in_required: 409,
	read_only: 403,
	recent_auth_required: 403,
	forbidden: 403,
	feature_disabled: 403,
	not_found: 404,
	stale_revision: 409,
	conflict: 409,
	idempotency_conflict: 409,
	payload_too_large: 413,
	validation_failed: 422,
	rate_limited: 429,
	quota_exceeded: 429,
	/** A report in the requested language waits for queued translations; retry, or export the original. */
	translation_pending: 409,
	/** Translation is off or its allowance is used up; export the original language instead. */
	translation_unavailable: 409,
	seat_limit_reached: 409,
	unavailable: 503,
	internal: 500
};
var AppError = class extends Error {
	code;
	status;
	fieldErrors;
	retryable;
	details;
	constructor(code, message, opts = {}) {
		super(message);
		this.code = code;
		this.status = statusForCode[code];
		this.fieldErrors = opts.fieldErrors;
		this.retryable = opts.retryable ?? (code === "unavailable" || code === "rate_limited");
		this.details = opts.details;
	}
};
const fail = (code, message, opts) => {
	throw new AppError(code, message, opts);
};
// src/constants.ts
const locales = [
	"en",
	"de",
	"es",
	"fr",
	"tr"
];
const defaultLocale = "en";
const featureKeys = [
	"tool.5s",
	"ai.template",
	"ai.voice",
	"ai.rewrite",
	"ai.import",
	"ai.questions",
	"ai.dashboard",
	"whiteLabel"
];
const aiFeatureKeys = [
	"ai.template",
	"ai.voice",
	"ai.rewrite",
	"ai.import",
	"ai.questions",
	"ai.dashboard"
];
/**
* Capabilities a plan can include, each optionally priced as an add-on. Automatic
* translation is a base platform function and never one of them.
*/
const planCapabilityKeys = [
	"whiteLabel",
	"ai.voice",
	"ai.rewrite",
	"ai.template",
	"ai.import",
	"ai.questions",
	"ai.dashboard"
];
/**
* Monthly allowances in units people understand: one dictation, one wording improvement, one generation. PDFs are
* generated in the browser and are never counted.
*/
const allowanceKeys = [
	"voice",
	"rewrite",
	"template",
	"import",
	"questions",
	"dashboard"
];
/** AI allowances and the plan capability that enables each. */
const aiAllowanceCapability = {
	voice: "ai.voice",
	rewrite: "ai.rewrite",
	template: "ai.template",
	import: "ai.import",
	questions: "ai.questions",
	dashboard: "ai.dashboard"
};
const limits = {
	remarksPerQuestion: 100,
	imagesPerRemark: 25,
	templateQuestions: 200,
	templateCategories: 20,
	widgetsPerPage: 30,
	/** Analytics pages shared with the whole workspace. */
	pagesPerWorkspace: 30,
	/** Private analytics pages one owner keeps in a workspace. */
	privatePagesPerOwner: 30,
	pageAssets: 61,
	imageUploadBytes: 10485760,
	logoUploadBytes: 2097152,
	audioUploadBytes: 5242880,
	/** Longest dictation; the server reads the length from the uploaded recording. */
	audioSeconds: 600,
	imageMaxMegapixels: 25,
	evidenceLongEdge: 2048,
	/**
	* Byte budget of one evidence photo (remark or finding). Browsers compress to it before upload; the server
	* refuses larger reservations and uploads whose bytes differ from the reserved size.
	*/
	evidenceMaxBytes: 614400,
	/**
	* Every stored image comes with a small preview the browser made, because the server does no image
	* processing; galleries and lists load it instead of the full image.
	*/
	thumbnailLongEdge: 400,
	thumbnailMaxBytes: 204800,
	/** Profile pictures: a square the browser crops and scales to 512 px; provider pictures are smaller. */
	avatarLongEdge: 1024,
	avatarMaxBytes: 1048576,
	uploadReservationMinutes: 15,
	invitationHours: 72,
	tokenMinutes: 30,
	sessionDays: 7,
	sessionInactivityHours: 12,
	operatorInactivityHours: 1,
	recentAuthMinutes: 5,
	idempotencyHours: 24,
	removalPlanMinutes: 15,
	socketTicketSeconds: 30,
	socketLeaseMinutes: 5,
	pageSizeDefault: 25,
	pageSizeMax: 100,
	jsonBodyBytes: 262144,
	templateBodyBytes: 2097152,
	csvImportBytes: 1048576,
	chartPointsPerSeries: 500,
	listRowsPerPage: 50,
	localDraftHours: 24,
	/** An agreement-change preview must be confirmed within this window (same as removal plans). */
	agreementPreviewMinutes: 15,
	/** Sidebar logos are stored as PNG with transparency, bounded on the long edge (preview: half of it). */
	logoLongEdge: 512
};
// src/short-id.ts
/**
* Short identifiers for URLs. Two forms exist:
*
* - Public identifiers: workspaces, audits, findings, templates and analytics pages have a stored random
*   11-character base62 identifier. Addresses and links use it; the API accepts it or the UUID in path
*   parameters and resolves it inside the authorized scope. Organizations have one too; the platform shows it
*   in its addresses and maps it to the UUID before calling the API.
* - The 22-character notation: a lossless base62 rewrite of a UUID. It is kept for identifiers without a
*   public one (people and areas in a query string, a UUID whose public identifier the browser has not seen
*   yet) and so links written in that form keep working. It is exactly as hard to guess as the UUID.
*
* Neither form is a secret; every request is authorized on the server as before.
*/
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const shortPattern = /^[0-9A-Za-z]{22}$/;
const shortLength = 22;
const publicIdPattern = /^[0-9A-Za-z]{11}$/;
const largest = (1n << 128n) - 1n;
/**
* Path segments that are followed by an identifier. Only those positions are encoded and decoded, so
* fixed segments and other tokens in a path (QR entry codes, help topics) are never touched.
*/
const identifierAfter = /* @__PURE__ */ new Set([
	"o",
	"w",
	"audits",
	"findings",
	"analytics",
	"templates",
	"workspaces",
	"organizations"
]);
/** The 22-character form of a UUID; any other value is returned unchanged. */
function shortId(uuid) {
	if (!uuidPattern.test(uuid)) return uuid;
	let n = BigInt(`0x${uuid.replaceAll("-", "")}`);
	let out = "";
	for (let i = 0; i < shortLength; i++) {
		out = `${alphabet[Number(n % 62n)] ?? "0"}${out}`;
		n /= 62n;
	}
	return out;
}
/** The UUID a 22-character identifier stands for, or null when the value is not one. */
function fromShortId(value) {
	if (!shortPattern.test(value)) return null;
	let n = 0n;
	for (const ch of value) n = n * 62n + BigInt(alphabet.indexOf(ch));
	if (n > largest) return null;
	const hex = n.toString(16).padStart(32, "0");
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function mapIdentifiers(path, map) {
	const segments = path.split("/");
	for (let i = 1; i < segments.length; i++) {
		const previous = segments[i - 1];
		const segment = segments[i];
		if (previous && segment && identifierAfter.has(previous)) segments[i] = map(segment);
	}
	return segments.join("/");
}
/** A path with every resource UUID written in its short form (`/o/<22>/w/<22>/audits/<22>`). */
function shortenPath(path) {
	return mapIdentifiers(path, shortId);
}
/** A path with short identifiers expanded back to UUIDs; UUIDs and other segments stay as they are. */
function expandPath(path) {
	return mapIdentifiers(path, (segment) => fromShortId(segment) ?? segment);
}
/** Whether a value is a stored public identifier (11 base62 characters). */
const isPublicId = (value) => publicIdPattern.test(value);
/** Whether a value is a UUID. */
const isUuid = (value) => uuidPattern.test(value);
/** A UUID, a public identifier or a 22-character UUID notation, normalized for an API path; null otherwise. */
function resourceRef(value) {
	if (uuidPattern.test(value)) return value.toLowerCase();
	if (publicIdPattern.test(value)) return value;
	return fromShortId(value);
}
/**
* A 5S address without the organization segment: `/o/<org>/w/<ws>/…` becomes `/w/<ws>/…`, since the
* workspace names its organization. Links written with the segment keep opening the same page.
*/
function dropOrganizationSegment(path) {
	return path.replace(/^\/o\/[^/]+(?=\/w\/[^/]+)/, "");
}
// src/app-links.ts
const appKeys = ["platform", "fiveS"];
const settingsPath = (organizationId, section) => section === "general" ? `/o/${organizationId}/settings` : `/o/${organizationId}/settings/${section}`;
/**
* 5S addresses name only the workspace: its public identifier, or its UUID where a caller has no
* public one. The tool finds the organization among the person's scopes.
*/
const workspace = (workspaceRef) => `/w/${workspaceRef}`;
/** Route builders for every link the server or another app needs to produce. */
const appLinks = {
	platformHome: () => ({
		app: "platform",
		path: "/"
	}),
	operatorDashboard: () => ({
		app: "platform",
		path: "/operator"
	}),
	operatorSecurity: () => ({
		app: "platform",
		path: "/operator/security"
	}),
	operatorOrganization: (organizationId) => ({
		app: "platform",
		path: `/operator/organizations/${organizationId}`
	}),
	mfaSetup: () => ({
		app: "platform",
		path: "/auth/setup-2fa"
	}),
	mfa: () => ({
		app: "platform",
		path: "/auth/mfa"
	}),
	/** Each app's page that clears its own browser state after a sign-out elsewhere (`?next=` continues). */
	signedOut: (app) => ({
		app,
		path: app === "platform" ? "/auth/signed-out" : "/signed-out"
	}),
	signIn: () => ({
		app: "platform",
		path: "/auth/sign-in"
	}),
	invitation: () => ({
		app: "platform",
		path: "/auth/invitation"
	}),
	resetPassword: () => ({
		app: "platform",
		path: "/auth/reset-password"
	}),
	verifyEmail: () => ({
		app: "platform",
		path: "/auth/verify-email"
	}),
	/** The one account page: profile, sign-in and security, notification emails. */
	account: () => ({
		app: "platform",
		path: "/account"
	}),
	/** The complete notification list, opened in place on the home page. */
	homeNotifications: () => ({
		app: "platform",
		path: "/?notifications=1"
	}),
	/** Authenticated help; a tool links to its own topic. */
	help: (topic) => ({
		app: "platform",
		path: topic ? `/help/${topic}` : "/help"
	}),
	organizationSettings: (organizationId, section) => ({
		app: "platform",
		path: settingsPath(organizationId, section)
	}),
	organizationWorkspace: (organizationId, workspaceId) => ({
		app: "platform",
		path: `/o/${organizationId}/workspaces/${workspaceId}`
	}),
	fiveSHome: () => ({
		app: "fiveS",
		path: "/"
	}),
	fiveSWorkspace: (workspaceRef) => ({
		app: "fiveS",
		path: workspace(workspaceRef)
	}),
	fiveSAuditEdit: (workspaceRef, auditRef) => ({
		app: "fiveS",
		path: `${workspace(workspaceRef)}/audits/${auditRef}/edit`
	}),
	fiveSFinding: (workspaceRef, findingRef) => ({
		app: "fiveS",
		path: `${workspace(workspaceRef)}/findings/${findingRef}`
	})
};
/** Absolute URL for a link given each app's configured origin, with short identifiers in the path. */
function appUrl(origins, link) {
	return `${origins[link.app].replace(/\/+$/, "")}${shortenPath(link.path)}`;
}
export { AcceptInvitation, Agreement, AgreementChange, AgreementConfirm, AgreementPreview, AgreementTerms, AgreementVersion, AgreementVersionList, AiCreate, AiDashboardSuggestion, AiQuestionContext, AiQuestionContextQuery, AiQuestionSuggestion, AiResult, AiTemplateImport, AllowanceResetPurchase, AllowanceUsage, AnalyticsPage, AnalyticsPageList, Answer, AnswerList, AnswerUpdate, AnswerValue, AppError, AppLink, AppearanceStyle, Area, AreaCreate, AreaList, AreaUpdate, Audit, AuditAccess, AuditAccessUpdate, AuditContext, AuditCreate, AuditList, AuditMetadata, AuditRevision, AuditSummary, AuditSummaryList, Avatar, AvatarProvider, Band, BillingDetails, BillingDetailsUpdate, BillingInvoice, BillingOverview, BillingPortal, Binary, BrandAccent, Branding, BrandingUpdate, Category, CategoryScore, ChartPoint, ChoiceOption, ConfigUpdate, ContactDetails, ContactMessage, DeleteOrganization, DraftCategory, DraftQuestion, DraftTemplateDefinition, Email, Empty, Entitlement, EntitlementUpdate, ErrorBody, FeatureGrant, Filters, Finding, FindingCreate, FindingEvent, FindingEventList, FindingObservation, FindingSummary, FindingSummaryList, FindingTransition, FindingUpdate, Grant, GridCell, GridCellFreeform, Impersonation, ImpersonationEnd, ImpersonationList, ImpersonationStart, ImportCsv, ImportPreview, Invitation, InvitationList, InvitationPreview, Invite, Job, JobList, LinkedAccount, LinkedAccountList, ListActivityQuery, ListAgreementVersionsQuery, ListAnswersQuery, ListAreasQuery, ListAuditsQuery, ListFindingEventsQuery, ListFindingsQuery, ListInvitationsQuery, ListMembersQuery, ListMyOrganizationsQuery, ListNotificationsQuery, ListPagesQuery, ListPlansQuery, ListRemarksQuery, ListRevisionRemarksQuery, ListScopesQuery, ListSessionsQuery, ListTemplateVersionsQuery, ListTemplatesQuery, ListWorkspacePeopleQuery, ListWorkspaceTemplateVersionsQuery, ListWorkspacesQuery, Media, MediaContentQuery, Member, MemberList, MemberUpdate, MfaAcknowledge, MfaChallenge, MfaRecoveryCodes, MfaSetup, Money, Notification, NotificationList, Ok, OperatorImpersonationsQuery, OperatorJobsQuery, OperatorMembersQuery, OperatorOrganizationsQuery, OperatorSecurityEvent, OperatorSecurityEventList, OperatorSecurityEventsQuery, OperatorSummary, OperatorWorkspacesQuery, Organization, OrganizationChoice, OrganizationChoiceList, OrganizationList, OrganizationPrivacyNotice, OrganizationPrivacyUpdate, OrganizationUpdate, PageAccessUpdate, PageAppearance, PageCreate, PageDefinition, PagePrint, PageUpdate, PageVersion, Passkey, PasskeyList, PasskeyRegistration, PasskeySignIn, PasswordChange, Plan, PlanAllowances, PlanCapability, PlanInput, PlanList, PlanTerms, PlanUpdate, PlatformConfig, PreviousAuditQuery, PreviousComparableAudit, PrivacyCommandExecution, PrivacyMaintenanceCommand, Profile, ProviderRedirect, Provision, Query, Question, ReasonedRevision, Reauthenticate, RecurringCost, Remark, RemarkCreate, RemarkList, RemarkUpdate, RemovalConfirm, RemovalPlan, RemovalSelection, ResetOffer, ResetPassword, Retention, RetentionUpdate, Revision, Scope, ScopeList, Score, Scoring, SecurityEvent, SecurityEventList, SecurityIncident, SecurityIncidentList, SecurityPolicy, SecurityPolicyUpdate, SeriesStyle, Session, SidebarBranding, SignIn, SignInOptions, SocialProvider, SocialSignIn, SocketHandshake, SocketRequest, SocketTicket, SocketUpgrade, Submit, Template, TemplateAreas, TemplateAreasUpdate, TemplateBrief, TemplateCreate, TemplateDefinition, TemplateFlags, TemplateList, TemplateMergeConflict, TemplateUpdate, TemplateVersion, TemplateVersionList, Token, ToolAccess, UploadReservation, UploadTicket, Usage, UserSession, UserSessionList, WebAuthnOptions, WhiteLabel, Widget, WidgetAnswerChange, WidgetAreaRow, WidgetContent, WidgetData, WidgetOptions, WidgetPresentation, WidgetPreview, WidgetQuery, WidgetReportQuery, Workspace, WorkspaceCreate, WorkspaceList, WorkspacePerson, WorkspacePersonList, WorkspaceUpdate, aiAllowanceCapability, aiFeatureKeys, allowanceKeys, appKeys, appLinks, appUrl, defaultLocale, dropOrganizationSegment, endpointById, endpoints, errorCodes, expandPath, fail, featureKeys, fromShortId, isPublicId, isUuid, limits, locales, planCapabilityKeys, resourceRef, schemas, shortId, shortenPath, statusForCode };

//# sourceMappingURL=index.mjs.map